<template >
  <main>
    <div class="container feedback template-bg-gray email-request-main-section" v-bind:class="{'my-position-relative': isStatus}" v-if="loaded && actionPageType === 'defPage'">
      <md-card class="request-status loop_container bg-transparent update-request-form-common" v-if="isStatus">
        <md-card-content class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main">
          <div class="card form-wrapper text-center p-20">
            <h4 class="template-custom-title" v-html="statusMsg"></h4>
          </div>
        </md-card-content>
      </md-card>
      <template>
        <snackbar ref="snackbar" baseSize="100px" :position="'top-center'" :wrapClass="''"
         :colors="{open: '#3DBD7D'}" :holdTime="5000" :multiple="false" aria-live="assertive">
        </snackbar>
      </template>
      <div class="row" v-if="!isStatus" aria-live="polite">
        <!-- && actionPageType === 'defPage' -->
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec">
          <div class="loop_container bg-transparent update-request-form-common" v-bind:class="{'emailreq-ty': success}">
            <div class="card form-wrapper">
              <div class="feedback_container feedback_newupdate">
                <div class="row">
                  <div class="col-md-12 text-center">
                    <img :src="logoURL" class="top-logo custom-logo" :alt="'Community Logo of '+ community.content.parameter2">
                  </div>
                </div>
                <div class="row common-space-from-logo" v-if="skip=== 'no'" v-show="!success">
                  <template v-if="action == 'yes'">
                  <div role="tablist"> <!-- TODO Start HERE  -->
                    <div class="col-sm-4 col-xs-12 text-center">
                      <button type="submit"
                        name="helpAction"
                        value="Share Advice"
                        :style="styleObjectBtn"
                        v-on:click.stop="expandContent('yes', 'Share Advice'); currentTab = 'yes-share-advice'; setButtonState('shareAdvice')"
                        class="btn-block btn template-button help-action-font-15 yesBtn"
                        id="shareAdviceBtn"
                        :class="{ active: currentTab === 'yes-share-advice', 'shareAdviceBtn': action === 'yes' }"
                        tabindex="0"
                        role="tab"
                      >
                        Share Advice
                      </button>
                    </div>
                    <div class="col-sm-4 col-xs-12 text-center center-button-div">
                      <button type="button"
                        name="helpAction"
                        value="Call Me"
                        :style="styleObjectBtn"
                        v-on:click="expandContent('yes', 'Call Me'); currentTab = 'yes-call-me'; setButtonState('callMe')"
                        class="btn-block btn template-button help-action-font-15 yesBtn"
                        :class="{ active: currentTab === 'yes-call-me' }"
                        tabindex="0"
                        role="tab"
                      >
                        Offer Call
                      </button>
                    </div>
                    <div class="col-sm-4 col-xs-12 text-center">
                      <button type="button"
                        name="helpAction"
                        value="Let's Connect"
                        :style="styleObjectBtn"
                        v-on:click="expandContent('yes', 'Let\'s Connect'); currentTab = 'yes-lets-connect'; setButtonState('letsConnect')"
                        class="btn-block btn template-button help-action-font-15 yesBtn"
                        :class="{ active: currentTab === 'yes-lets-connect' }"
                        role="tab"
                        tabindex="0"
                      >
                        Suggest Meeting
                      </button>
                    </div>
                  </div>
                  </template>
                  <template v-if="action == 'no'">
                    <div role="tablist">
                    <div class="col-sm-4 col-xs-12 text-center">
                      <button type="submit"
                        name="helpAction"
                        role="tab"
                        value="Not Available"
                        v-on:click="expandContent('no', $event.target.textContent); currentTab = 'no-not-available'" class="btn-block btn template-button help-action-font-15 md-red" id="notAvailableBtn" :class="{'no-btn-active': currentTab === 'no-not-available'}">Not Available</button>
                    </div>
                                        <div class="col-sm-4 col-xs-12 text-center center-button-div">
                                            <button type="submit"
                                                name="helpAction"
                                                value="Not Relevant"
                                                role="tab"
                                                v-on:click="expandContent('no', 'Not Relevant'); currentTab = 'no-not-relevant'" class="btn-block btn template-button help-action-font-15 md-red" :class="{'no-btn-active': currentTab === 'no-not-relevant'}">Not A Fit For Me</button>
                                        </div>
                                        <div class="col-sm-4 col-xs-12 text-center">
                                            <button type="submit"
                                                name="helpAction"
                                                role="tab"
                                                value="Not A Good Question"
                                                v-on:click="expandContent('no', $event.target.textContent); currentTab = 'no-not-good-question'" class="btn-block btn template-button help-action-font-15 md-red" :class="{'no-btn-active': currentTab === 'no-not-good-question'}">Not A Good Question</button>
                                        </div>
                                     </div>
                                    </template>
                                </div>
                                <div class="row" v-if="skip=== 'no'" v-show="!success">
                                    <div class="col-sm-12 text-center mt-10">
                                        <a tabindex="0" class="email-request-link" @click="shareRequest()" role="link">I know someone who can help</a>
                                    </div>
                                </div>
                                <div class="row email-request-form-container" v-if="opened.includes('yes') && action == 'yes'" v-show="!success">
                                    <form @submit.prevent="helpaction(buttonText)" class="template-form">
                                        <div class="row my-2" v-if="buttonText.search(/Share Advice/i) !== -1 || (buttonText.search(/Call Me/i) !== -1 && (memberid === 'undefined' || typeof memberid === 'undefined' || memberid === 'null' || memberid === ''))">
                                            <div class="col-sm-12">
                                                <!--p class="text-center email-request-ptext" v-if="buttonText.search(/Share Advice/i) !== -1">Please enter your response below and we will share it with the requesting member (you will get a copy of the response).</p-->
                                                <!--p class="text-center email-request-ptext" v-if="buttonText.search(/Call Me/i) !== -1 && (memberid === 'undefined' || typeof memberid === 'undefined' || memberid === 'null' || memberid === '')">Please enter your phone number below and we will forward it to the community member.</p-->
                                            </div>
                                        </div>
                                        <div v-if="buttonText.search(/Let's Connect/i) !== -1" class="row my-2">
                                            <div class="col-sm-12">
                                                <!--p class="text-center email-request-ptext">Please suggest a physical or virtual meeting option that we can share with the community member.</p-->
                                            </div>
                                            <!-- <div class="row my"></div>
                                                <div class="row my"></div> -->
                                        </div>
                                        <div class="col-lg-6 col-md-8 col-sm-8" v-if="memberid === 'undefined' || typeof memberid === 'undefined' || memberid === 'null' || memberid === ''">
                                            <div class="form-group remove-formgroup-margin">
                                                <label class="mt-0 template-label">First Name</label>
                                                <input
                                                    aria-label="Input, enter your first name"
                                                    type="text"
                                                    class="form-control input-value"
                                                    id="first_yes"
                                                    name="feedback_first"
                                                    v-validate="'required|alpha_spaces'"
                                                    v-model="first"
                                                    @keyup="updateSubmitBtnDisabled"
                                                    placeholder="What's your first name?"
                                                    v-focus
                                                    @input="e => first = sanitizeInput(e.target.value)"
                                                    >
                                                <p class="error" v-show="errors.has('feedback_first')">{{errors.first('feedback_first')}}</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-8 col-sm-8" v-if="memberid === 'undefined' || typeof memberid === 'undefined' || memberid === 'null' || memberid === ''">
                                            <div class="form-group remove-formgroup-margin">
                                                <label class="mt-0 template-label">Last Name</label>
                                                <input
                                                    aria-label="Input, enter your last name."
                                                    type="text"
                                                    class="form-control input-value"
                                                    id="last_yes"
                                                    name="feedback_last"
                                                    v-validate="'required|alpha_spaces'"
                                                    v-model="last"
                                                    @keyup="updateSubmitBtnDisabled"
                                                    placeholder="What's your last name?"
                                                    @input="e => last = sanitizeInput(e.target.value)"
                                                    >
                                                <p class="error" v-show="errors.has('feedback_last')">{{errors.first('feedback_last')}}</p>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-md-8 col-sm-8" v-if="memberid === 'undefined' || typeof memberid === 'undefined' || memberid === 'null' || memberid === ''">
                                            <div class="form-group remove-formgroup-margin">
                                                <label class="mt-0 template-label">Email Address</label>
                                                <input
                                                    aria-label="Input, enter your email address"
                                                    type="text"
                                                    class="form-control input-value"
                                                    id="email_yes"
                                                    name="feedback_email"
                                                    v-validate="'required|email|max:60'"
                                                    v-model="email"
                                                    @keyup="updateSubmitBtnDisabled"
                                                    placeholder="What's your email address?"
                                                    @input="e => email = sanitizeInput(e.target.value)"
                                                    >
                                                <p class="error" v-show="errors.has('feedback_email')">{{errors.first('feedback_email')}}</p>
                                            </div>
                                        </div>
                                        <div v-if="buttonText.search(/Call Me/i) !== -1 && (memberid === 'undefined' || typeof memberid === 'undefined' || memberid === 'null' || memberid === '')">
                                            <div class="col-sm-6 ml-1">
                                                <div class="input-group">
                                                    <p class="required-note template-label" id="required-note">
                                                        Fields marked with an asterisk (<span class="required-symbol">*</span>) are required.
                                                    </p>
                                                    <label class="template-label">What is your phone number? <span class="required-symbol"> *</span></label>
                                                    <input
                                                        aria-label="Input, enter your phone number"
                                                        type="text"
                                                        class="form-control input-value"
                                                        name="phoneNo"
                                                        v-model="phoneNo"
                                                        required
                                                        aria-required="true"
                                                        @keyup="updateSubmitBtnDisabled"
                                                        v-validate.continues="'required|numeric'"
                                                        placeholder="(999) 999-9999"
                                                        v-focus
                                                        @input="e => phoneNo = sanitizeInput(e.target.value)"
                                                        >
                                                        <p class="error" v-show="errors.has('phoneNo')">{{errors.first('phoneNo')}}</p>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="input-group disclaimer">
                                                    <md-checkbox name="calltext" v-model="callText"
                                                    class="form-control template-checkbox pt-0 my-15">Check this box if the individual can text you at this number</md-checkbox>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="input-group ">
                                                    <label class="template-label">Message<span class="required-symbol"> *</span></label>
                                                    <div class="template-input-text-area common-question-textarea-for-v1-v2 unsubscribe-height">
                                                        <textarea
                                                        aria-label="Offer call textarea, character count available"
                                                        aria-describedby="char-counter-offercall"
                                                        class="form-control call-me-height placeholder-bold"
                                                        name="call-message"
                                                        v-validate.continues="'required|max:5000|min:25'"
                                                        v-on:keyup="countdown"
                                                        @keyup="updateSubmitBtnDisabled"
                                                        rows="20"
                                                        aria-required="true"
                                                        required
                                                        :maxlength="max"
                                                        :placeholder="'[Click here to edit] \n' + actionFormTipsPlaceholder(community.content.actionFormCallTips)"
                                                        v-model="callMessage"
                                                        v-bind:class="{'request-form-error-border': errors.has('call-message') }"
                                                        @input="e => callMessage = sanitizeInput(e.target.value)"
                                                        ></textarea>
                                                        <div class="form-group pd-remove unsubscribe-btn mb-0-custom">
                                                            <div
                                                                id="char-counter-offercall" aria-live="polite"
                                                                class="char-counter template-subject-counter"
                                                                v-bind:class="{'char-count-error': exceedsMaxCount }"
                                                            >{{remainingCountCall}}  / 5000 <span class="sr-only">characters</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p class="error" v-show="errors.has('call-message')">{{errors.first('call-message')}}</p>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="form-group remove-formgroup-margin unsubscribe-btn btn-other text-right">
                                                    <button type="submit"
                                                        name="helpAction"
                                                        v-bind:style="styleObjectBtn"
                                                        class="btn template-button submitBtn btn_info">Submit</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <div v-if="buttonText.search(/Share Advice/i) !== -1">
                                                <div class="input-group remove-formgroup-margin mt-10">
                                                    <!-- <label>Message</label> -->
                                                    <label class="template-label">Message<span class="required-symbol"> *</span></label>
                                                    <div class="template-input-text-area common-question-textarea-for-v1-v2 unsubscribe-height" ref="afterClick">
                                                        <textarea
                                                            class="form-control placeholder-bold"
                                                            name="feedback_comment"
                                                            aria-describedby="char-counter-advice"
                                                            v-validate.continues="'required|max:5000|min:50'"
                                                            aria-label="Write your advice here textarea, character count available"
                                                            v-on:keyup="countdown"
                                                            @keyup="updateSubmitBtnDisabled"
                                                            rows="20"
                                                            :maxlength="max"
                                                            :placeholder="'[Click here to edit] \n' + actionFormTipsPlaceholder(community.content.actionFormAdviceTips)"
                                                            required
                                                            aria-required="true"
                                                            v-model="feedback_comment"
                                                            v-bind:class="{'request-form-error-border': errors.has('feedback_comment') }"
                                                            @input="e => { feedback_comment = sanitizeInput(e.target.value); detectContactInfo(feedback_comment); }"
                                                            ></textarea>
                                                            <div class="form-group pd-remove unsubscribe-btn mb-0-custom">
                                                                <div
                                                                    id="char-counter-advice"
                                                                    class="char-counter template-subject-counter"
                                                                    v-bind:class="{'char-count-error': exceedsMaxCount }"
                                                                >{{remainingCountAdvice}}  / 5000 <span class="sr-only">characters</span></div>
                                                                </div>
                                                    </div>
                                                    <div v-if="contactInfoDetected === false"
                                                        class="contact-detection-banner">
                                                        <span class="contact-detection-icon">!</span>
                                                        <div class="contact-detection-text">
                                                            <strong>No contact information detected</strong>
                                                            <p>Make it easy for people to connect with you: add your email, phone number, or scheduling link!</p>
                                                        </div>
                                                    </div>
                                                    <p class="error" role="alert" aria-live="assertive" v-if="errors.has('feedback_comment')" :key="errors.first('feedback_comment')">{{errors.first('feedback_comment')}}</p>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <div class="form-group remove-formgroup-margin unsubscribe-btn btn-other text-right">
                                                            <button type="submit"
                                                                name="helpAction"
                                                                v-bind:style="styleObjectBtn"
                                                                class="btn template-button submitBtn btn_info">Submit</button>
                                                        </div>
                                            </div>
                                                </div>
                                                <p class="txtError" v-if="textError">If you have a lot of information to share with the individual, consider offering a call or a meeting. </p>
                                            </div>

                                            <div v-if="buttonText.search(/Let's Connect/i) !== -1">
                                                <label class="template-label">Message<span class="required-symbol"> *</span></label>
                                                <div class="input-group unsubscribe-height template-input-text-area common-question-textarea-for-v1-v2 mt-10">
                                                        <textarea
                                                            aria-label="Suggest meeting textarea, character count available"
                                                            aria-describedby="char-counter-meeting"
                                                            class="form-control pt-input request-form-question-textarea placeholder-bold"
                                                            name="feedback_comment2"
                                                            v-validate.continues="'required|max:5000|min:25'"
                                                            v-on:keyup="countdown"
                                                            @keyup="updateSubmitBtnDisabled"
                                                            rows="20"
                                                            :maxlength="max"
                                                            :placeholder="'[Click here to edit] \n' + actionFormTipsPlaceholder(community.content.actionFormMeetingTips)"
                                                            v-model="feedback_comment2"
                                                            v-bind:class="{'request-form-error-border': errors.has('feedback_comment2') }"
                                                            @input="e => { feedback_comment2 = sanitizeInput(e.target.value); detectContactInfo(feedback_comment2); }"
                                                            ></textarea>
                                                            <div class="form-group pd-remove unsubscribe-btn mb-0-custom">
                                                                <div
                                                                    id="char-counter-meeting" aria-live="polite"
                                                                    class="char-counter template-subject-counter"
                                                                    v-bind:class="{'char-count-error': exceedsMaxCount }"
                                                                >{{remainingCountConnect}}  / 5000 <span class="sr-only">characters</span>
                                                                </div>
                                                            </div>
                                                            <p class="error" role="alert" aria-live="assertive"
                                                        v-show="errors.has('feedback_comment2')"
                                                        :key="errors.first('feedback_comment2')">
                                                        {{ errors.first('feedback_comment2') }}</p>
                                                </div>
                                                <div v-if="contactInfoDetected === false"
                                                        class="contact-detection-banner">
                                                        <span class="contact-detection-icon">!</span>
                                                        <div class="contact-detection-text">
                                                            <strong>No contact information detected</strong>
                                                            <p>Make it easy for people to connect with you: add your email, phone number, or scheduling link!</p>
                                                        </div>
                                                    </div>
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <div class="form-group remove-formgroup-margin unsubscribe-btn btn-other text-right">
                                                            <button type="submit"
                                                                name="helpAction"
                                                                v-bind:style="styleObjectBtn"
                                                                class="btn template-button submitBtn btn_info">Submit</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div class="row email-actionpage-content" v-if="opened.includes('no') && action == 'no'" v-show="!success">
                                    <form @submit.prevent="helpaction(buttonText)" class="template-form">
                                        <div class="col-sm-12">
                                            <div class="text-center mb-20 email-actionpage-upadate-inner not-available-heading  my-15" v-if="buttonText.search(/Not Available/i) !== -1">
                                                <h2>
                                                    Thanks for letting us know.
                                                    <template v-if="memberid !== 'undefined' && (typeof memberid !== 'undefined') && memberid !== 'null' && memberid !== ''">
                                                        You can now close this window.
                                                    </template>
                                                </h2>
                                                <hr class="not-available-hr" />
                                                <div v-if="memberid !== 'undefined' && (typeof memberid !== 'undefined') && memberid !== 'null' && memberid !== ''">
                                                    <h2 class="boldheading">Know someone else who could help?</h2>
                                                    <p>Please let us know below and we will forward the request on your behalf.
                                                        Note that we will not use your contact's information for any other purposes.</p>
                                                </div>
                                            </div>
                                            <div class="text-center mb-20 email-actionpage-upadate-inner not-available-heading  my-15" v-if="buttonText.search(/Not Relevant/i) !== -1">
                                                <h2>Thanks for letting us know.</h2>
                                                <template v-if="memberid !== 'undefined' && (typeof memberid !== 'undefined') && memberid !== 'null' && memberid !== ''">
                                                    <br/>
                                                    <h1 class="white-space-content">
                                                        Please update your profile on <a target="_blank" class="link inline-block" v-bind:href="community.communitySite">{{ this.community.communitySite }}</a>
                                                        so that we can better match you to requests.
                                                    </h1>
                                                </template>
                                                <hr/>
                                                <div v-if="memberid !== 'undefined' && (typeof memberid !== 'undefined') && memberid !== 'null' && memberid !== ''">
                                                    <h2 class="boldheading">Know someone else who could help?</h2>
                                                    <p>Please let us know below and we will forward the request on your behalf.
                                                        Note that we will not use your contact's information for any other purposes.</p>
                                                </div>
                                            </div>

                                            <div class="text-center mb-20 email-actionpage-upadate-inner not-available-heading  my-15" v-if="buttonText.search(/Not A Good Question/i) !== -1">
                                                <h2>Thanks for letting us know.</h2>
                                                <br/>
                                                <h2>Why do you feel that this is not a good question?</h2>
                                            </div>
                                            <!-- Display selection field when click on Not A Good Question Action -->
                                            <div class="row">
                                                <div class="col-sm-6 col-sm-offset-3 req-page-select"
                                                    v-if="buttonText.search(/Not A Good Question/i) !== -1 &&
                                                        (typeof this.memberid !== 'undefined') &&
                                                        this.memberid !== 'undefined' &&
                                                        this.memberid !== 'null' &&
                                                        this.memberid !== ''">
                                                    <div class="m-left-5 create-rule">
                                                        <label for="reason-select-1" id="reason-label" class="sr-only">
                                                            Select a reason
                                                        </label>
                                                        <select
                                                            id="reason-select-1"
                                                            class="form-control placeholder-color roboto-slab-class"
                                                            v-model="selectedResponse"
                                                            @change="submitNegativeResponse(buttonText, selectedResponse)"
                                                            aria-labelledby="reason-label"
                                                            :aria-expanded="isExpanded.toString()"
                                                        >
                                                            <option value="" disabled selected style="display:none">
                                                                Please select a reason
                                                            </option>
                                                            <option v-for="(reason, index) in responsesArr"
                                                                    :key="index"
                                                                    :value="reason">
                                                                {{ reason }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-sm-6 col-sm-offset-3 mb-20 req-page-select"
                                                    v-else-if="buttonText.search(/Not A Good Question/i) !== -1">
                                                    <div class="m-left-5 create-rule">
                                                        <label for="reason-select-2" id="reason-label-2" class="sr-only">
                                                            Select a reason
                                                        </label>
                                                        <select
                                                            id="reason-select-2"
                                                            class="form-control placeholder-color roboto-slab-class"
                                                            v-model="selectedResponse"
                                                            v-validate="'required'"
                                                            name="reason"
                                                            :aria-describedby="errors.has('reason') ? 'error-reason' : null"
                                                            aria-labelledby="reason-label-2"
                                                            :aria-expanded="isExpanded.toString()"
                                                        >
                                                            <option value="" disabled selected style="display:none">
                                                                Please select a reason
                                                            </option>
                                                            <option v-for="(reason, index) in responsesArr"
                                                                    :key="index"
                                                                    :value="reason">
                                                                {{ reason }}
                                                            </option>
                                                        </select>
                                                        <p
                                                            v-show="errors.has('reason')"
                                                            id="error-reason"
                                                            class="error m-left-5"
                                                        >
                                                            {{ errors.first('reason') }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Display selection field when click on Not A Good Question Action -->
                                            <div class="row" v-if="memberid === 'undefined' || typeof memberid === 'undefined' || memberid === 'null' || memberid === ''">
                                                <div class="col-lg-6 col-md-8 col-sm-8">
                                                    <div class="form-group remove-formgroup-margin" >
                                                        <label class="template-label">First Name</label>
                                                        <input
                                                            type="text"
                                                            id="first_no"
                                                            class="form-control input-value"
                                                            name="feedback_first"
                                                            @keyup="updateSubmitBtnDisabled"
                                                            v-validate="'required|alpha_spaces'"
                                                            v-model="first"
                                                            placeholder="What's your first name?"
                                                            v-focus
                                                            @input="e => first = sanitizeInput(e.target.value)"
                                                            >
                                                        <p class="error" v-show="errors.has('feedback_first')">{{errors.first('feedback_first')}}</p>
                                                    </div>
                                                </div>
                                                <div class="col-lg-6 col-md-8 col-sm-8">
                                                    <div class="form-group remove-formgroup-margin" >
                                                        <label class="template-label">Last Name</label>
                                                        <input
                                                            type="text"
                                                            id="last_no"
                                                            class="form-control input-value"
                                                            name="feedback_last"
                                                            @keyup="updateSubmitBtnDisabled"
                                                            v-validate="'required|alpha_spaces'"
                                                            v-model="last"
                                                            placeholder="What's your last name?"
                                                            @input="e => last = sanitizeInput(e.target.value)"
                                                            >
                                                        <p class="error" v-show="errors.has('feedback_last')">{{errors.first('feedback_last')}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row" v-if="memberid === 'undefined' || typeof memberid === 'undefined' || memberid === 'null' || memberid === ''">
                                                <div class="col-lg-6 col-md-8 col-sm-8">
                                                    <div class="form-group remove-formgroup-margin" >
                                                        <label class="template-label">Email Address</label>
                                                        <input
                                                            type="text"
                                                            id="email_no"
                                                            class="form-control input-value"
                                                            name="feedback_email"
                                                            @keyup="updateSubmitBtnDisabled"
                                                            v-validate="'required|email|max:60'"
                                                            v-model="email"
                                                            placeholder="What's your email address?"
                                                            @input="e => email = sanitizeInput(e.target.value)"
                                                            >
                                                        <p class="error" v-show="errors.has('feedback_email')">{{errors.first('feedback_email')}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12" v-if="memberid === 'undefined' || typeof memberid === 'undefined' || memberid === 'null' || memberid === ''">
                                                <div class="form-group remove-formgroup-margin unsubscribe-btn btn-other text-right">
                                                    <button type="submit"
                                                        name="helpAction"
                                                        v-bind:style="styleObjectBtn"
                                                        class="btn template-button submitBtn btn_info">Submit</button>
                                                </div>
                                        </div>
                                    </form>
                                </div>
                                <div class="row email-request-form-container" v-if="action === 'yes' && buttonText.search(/Call Me/i) !== -1 && (memberid !== 'undefined' && typeof memberid !== 'undefined' && memberid !== 'null' && memberid !== '')" v-show="!success">
                                    <form @submit.prevent="helpaction(buttonText)" class="template-form">
                                        <div class="row my-2">
                                            <div class="col-sm-12">
                                                <!--p class="text-center email-request-ptext">Please enter your phone number below and we will forward it to the community member.</p-->
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <div class="input-group">
                                                <p class="required-note template-label" id="required-note">
                                                    Fields marked with an asterisk (<span class="required-symbol">*</span>) are required.
                                                </p>
                                                <label class="template-label">What is your phone number?<span class="required-symbol"> *</span></label>
                                                <input
                                                    aria-describedby="phone-example"
                                                    aria-label="Phone number input"
                                                    type="tel"
                                                    autocomplete="tel"
                                                    class="form-control input-value placeholder-bold"
                                                    name="phoneNo"
                                                    v-model="phoneNo"
                                                    required
                                                    aria-required="true"
                                                    @keyup="updateSubmitBtnDisabled"
                                                    v-validate.continues="'required|numeric'"
                                                    placeholder="(999) 999-9999"
                                                    @input="e => phoneNo = sanitizeInput(e.target.value)"
                                                    >
                                                    <span id="phone-example" class="sr-only">
                                                        Example format: area code, followed by a three-digit prefix, and a four-digit line number.
                                                    </span>
                                                    <p class="error" v-show="errors.has('phoneNo')">{{errors.first('phoneNo')}}</p>
                                            </div>
                                        </div>
                                        <!--div class="col-sm-12">
                                        <div class="input-group disclaimer">
                                            <div class="input-group disclaimer">
                                                <label for="calltext" aria-label="Check this box if the individual can text you at this number">
                                                    <input
                                                    id="calltext"
                                                    type="checkbox"
                                                    v-model="callText"
                                                    tabindex="0"
                                                    role="checkbox"
                                                    :aria-checked="callText ? 'true' : 'false'"
                                                    class="form-control template-checkbox pt-0 my-15"
                                                    />
                                                    Check this box if the individual can text you at this number
                                                </label>
                                                </div>
                                            </div>
                                        </div-->
                                        <div class="col-sm-12">
                                            <div class="input-group ">
                                                <label class="template-label">Message<span class="required-symbol"> *</span></label>
                                                <div class="template-input-text-area common-question-textarea-for-v1-v2 unsubscribe-height">
                                                    <textarea
                                                    aria-label="Message textarea, character count available."
                                                    aria-describedby="character-count-message"
                                                    class="form-control call-me-height placeholder-bold"
                                                    name="call-message"
                                                    v-validate.continues="'required|max:5000|min:25'"
                                                    v-on:keyup="countdown"
                                                    @keyup="updateSubmitBtnDisabled"
                                                    rows="20"
                                                    :maxlength="max"
                                                    :placeholder="'[Click here to edit] \n' + actionFormTipsPlaceholder(community.content.actionFormCallTips)"
                                                    required
                                                    aria-required="true"
                                                    v-model="callMessage"
                                                    v-bind:class="{'request-form-error-border': errors.has('call-message') }"
                                                    @input="e => callMessage = sanitizeInput(e.target.value)"
                                                    ></textarea>
                                                    <div class="form-group pd-remove unsubscribe-btn mb-0-custom">
                                                        <div
                                                            id="character-count-message" aria-live="polite"
                                                            class="char-counter template-subject-counter"
                                                            v-bind:class="{'char-count-error': exceedsMaxCount }"
                                                        >{{remainingCountCall}}  / 5000 <span class="sr-only">characters</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p class="error" v-show="errors.has('call-message')">{{errors.first('call-message')}}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-12 col-sm-12 text-right">
                                                <div class="form-group remove-formgroup-margin unsubscribe-btn btn-other text-right">
                                                    <button type="submit"
                                                        name="helpAction"
                                                        v-bind:style="styleObjectBtn"
                                                        class="btn template-button submitBtn btn_info">Submit</button>
                                                </div>
                                        </div>
                                    </form>
                                </div>
                                <!-- <p align="center" v-show="success" class="success-message">Thank you. We will share your response with the individual.</p> -->
                                <div class="row" v-if="(success && action == 'yes') || (successReferral == true && action == 'no') || (success && successReferral === false && action == 'no' && (memberid === 'undefined' || typeof memberid === 'undefined' || memberid === 'null' || memberid === ''))"  >
                                    <div class="col-md-12 text-center common-space-from-logo">
                                        <div class='header-text text-center unsubscribepage-thankumsg' v-bind:class="{'email-actionpage-tmsg': !success}">
                                            <h1 class="template-title mt-0" :key="successMsg">{{successMsg}}</h1>
                                            <div v-if="(typeof this.memberid !== 'undefined') && this.memberid !== 'undefined' && this.memberid !== 'null' && this.memberid !== '' && !emailUpdate">
                                                <div v-if="isProfileValidation && !isEmailSection & isUpdateProfileFlag" v-click-outside="outside">
                                                    <p class="custom-content">We matched you to this request based on the below  information. Is this still correct?</p>
                                                    <p class="custom-content" v-if="adviser.profileValidationFlag == configureFields.profileUpdateInterest">Please choose (or remove) interests that we may use to match you to relevant requests.</p>
                                                    <div class="" v-bind:class = "(adviser.profileValidationFlag == configureFields.profileUpdateInterest)?'interest-div':'emailreq-profileupdate'">
                                                        <div v-if="adviser.profileValidationFlag == configureFields.profileUpdateOccupation">
                                                            <!--div v-if = "!isEditing">
                                                                <div class="row">
                                                                    <div class="col-lg-2 col-xs-4 update-profile-response-label">Role:</div>
                                                                    <div class="col-lg-10 col-xs-8 update-profile-response-value rowProfileUpdate"> <b> {{memberObj.memberRoles ? memberObj.memberRoles: 'N/A'}}</b> </div>
                                                                </div>
                                                                <div class="row py-5">
                                                                    <div class="col-lg-2 col-xs-4 update-profile-response-label">Organization:</div>
                                                                    <div class="col-lg-10 col-xs-8 update-profile-response-value rowProfileUpdate"> <b> {{memberObj.organization ? memberObj.organization: 'N/A'}}</b> </div>
                                                                </div>
                                                            </div-->
                                                            <div v-if = "isEditing && community.communityPortal=='protopia'">
                                                                <div class="row">
                                                                    <div class="col-lg-2 col-xs-4 update-profile-response-label">Role:</div>
                                                                    <div class="col-lg-10 col-xs-8">
                                                                        <md-field class="profileValidation">
                                                                            <md-input class="d-block-w-100 update-profile-template-input" @input="saveChanges" aria-describedby="role-description" v-focus v-model="memberObj.memberRoles" name="memberRoles" aria-label="Role"></md-input>
                                                                            <div id="role-description" class="sr-only">
                                                                                Please enter your role.
                                                                            </div>                                                                        </md-field>
                                                                    </div>
                                                                </div>
                                                                <div class="row py-10">
                                                                    <div class="col-lg-2 col-xs-4 update-profile-response-label">Organization:</div>
                                                                    <div class="col-lg-10 col-xs-8">
                                                                        <md-field class="profileValidation">
                                                                            <md-input class="d-block-w-100 update-profile-template-input" aria-describedby="org-description" @input="saveChanges" v-model="memberObj.organization" name="organization" aria-label="Organization"></md-input>
                                                                            <div id="org-description" class="sr-only">
                                                                                Please enter your organization name.
                                                                            </div>
                                                                        </md-field>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="mb-0" v-if="adviser.profileValidationFlag == configureFields.profileUpdateInterest">
                                                            <div class="row text-center my">
                                                                <template v-for="randomInterestItem in randomInterest">
                                                                    <div class="col-md-4 col-sm-4 col-xs-6 width100" v-bind:key="randomInterestItem">
                                                                        <md-checkbox class="my-round-checkbox" :key="randomInterestItem" v-model="selectedInterestList" :value="randomInterestItem" :name="randomInterestItem">{{randomInterestItem}}<md-tooltip md-direction="right">{{randomInterestItem}}</md-tooltip></md-checkbox>
                                                                    </div>
                                                                </template>
                                                            </div>
                                                        </div>
                                                        <div v-if="adviser.profileValidationFlag == configureFields.profileUpdateGeography">
                                                            <!--div v-if = "!isEditing">
                                                                <div class="row">
                                                                    <div class="col-lg-2 update-profile-response-label col-xs-4">City:</div>
                                                                    <div class="col-lg-10 update-profile-response-value rowProfileUpdate col-xs-8"> <b> {{memberObj.city ? memberObj.city: 'N/A'}}</b> </div>
                                                                </div>
                                                                <div class="row py-5">
                                                                    <div class="col-lg-2 col-xs-4 update-profile-response-label" aria-live="polite">State:</div>
                                                                    <div class="col-lg-10 col-xs-8 update-profile-response-value rowProfileUpdate"> <b> {{memberObj.state ? memberObj.state: 'N/A'}}</b> </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-2 col-xs-4 update-profile-response-label" aria-live="polite">Country:</div>
                                                                    <div class="col-lg-10 col-xs-8 update-profile-response-value rowProfileUpdate"> <b> {{memberObj.country ? memberObj.country: 'N/A'}}</b> </div>
                                                                </div>
                                                            </div-->
                                                            <div v-if = "isEditing && community.communityPortal=='protopia'">
                                                                <div class="row">
                                                                    <div class="col-lg-2 col-xs-4 update-profile-response-label" aria-live="polite">
                                                                        <label for="city-input">City:</label>
                                                                    </div>
                                                                    <div class="col-lg-10 col-xs-8">
                                                                        <md-field class="profileValidation">
                                                                           <md-input id="city-input" class="d-block-w-100 update-profile-template-input" aria-describedby="city-description" @input="saveChanges" v-focus v-model="memberObj.city" name="city" aria-label="City"></md-input>
                                                                            <div id="city-description" class="sr-only">
                                                                                Please enter your city.
                                                                            </div>
                                                                        </md-field>
                                                                    </div>
                                                                </div>
                                                                <div class="row py-10">
                                                                   <div class="col-lg-2 col-xs-4 update-profile-response-label" aria-live="polite">
                                                                        <label for="state-input">State:</label>
                                                                    </div>
                                                                    <div class="col-lg-10 col-xs-8">
                                                                        <md-field class="profileValidation">
                                                                            <md-input id="state-input" class="d-block-w-100 update-profile-template-input" @input="saveChanges" aria-describedby="state-description" v-model="memberObj.state" name="state" aria-label="State"></md-input>
                                                                            <div id="state-description" class="sr-only">
                                                                                Please enter your state.
                                                                            </div>
                                                                        </md-field>
                                                                    </div>
                                                                </div>
                                                                <div class="row">
                                                                    <div class="col-lg-2 col-xs-4 update-profile-response-label" aria-live="polite">
                                                                        <label for="country-input">Country:</label>
                                                                    </div>
                                                                    <div class="col-lg-10 col-xs-8">
                                                                        <md-field class="profileValidation">
                                                                            <md-input id="country-input" class="d-block-w-100 update-profile-template-input" @input="saveChanges" aria-describedby="country-description" v-model="memberObj.country" name="country" aria-label="Country"></md-input>
                                                                            <div id="country-description" class="sr-only">
                                                                                Please enter your country.
                                                                            </div>
                                                                        </md-field>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-if="adviser.profileValidationFlag == configureFields.profileUpdatePhoneNumber">
                                                            <!--div v-if = "!isEditing"-->
                                                                <!--div class="row" style="display: flex;">
                                                                    <div class="col-lg-1 col-sm-1 update-profile-response-label width100" aria-live="polite" style="width: auto; white-space: nowrap;">Phone Number:</div>
                                                                    <div class="col-lg-11 col-sm-11 update-profile-response-value rowProfileUpdate"> <b> {{memberObj.phoneNumbers && memberObj.phoneNumbers.length && memberObj.phoneNumbers[0] !== "" ? memberObj.phoneNumbers[0]: 'N/A'}}</b> </div>
                                                                </div>
                                                            </div-->
                                                            <!--/div-->
                                                            <!--div v-if = "isEditing && community.communityPortal=='protopia'"-->
                                                                <div class="row" style="display: flex;">
                                                                    <div class="col-lg-1 col-sm-1 update-profile-response-label width100" aria-live="polite" style="width: auto; white-space: nowrap;">Phone Number:</div>
                                                                    <div class="col-lg-11 col-sm-11">
                                                                        <md-field class="profileValidation">
                                                                            <md-input class="d-block-w-100 update-profile-template-input" aria-describedby="phonenumber-description" @input="saveChanges" v-focus v-model.trim="phoneInput" name="phoneNumbers" aria-label="Phone Number"></md-input>
                                                                            <div id="phonenumber-description" class="sr-only">
                                                                                Please enter your phone number.
                                                                            </div>
                                                                        </md-field>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        <!--/div-->
                                                        <div v-if="adviser.profileValidationFlag == configureFields.profileUpdateLinkedInUrl">
                                                            <!--div v-if = "!isEditing">
                                                                <div class="row" style="display: flex;">
                                                                    <div class="col-lg-2 col-sm-2 update-profile-response-label width100" aria-live="polite" style="width: auto; white-space: nowrap;">LinkedIn Url:</div>
                                                                    <div class="col-lg-10 col-sm-10 update-profile-response-value rowProfileUpdate"> <b> {{memberObj.linkedIn ? memberObj.linkedIn : 'N/A'}}</b> </div>
                                                                </div>
                                                            </div-->
                                                            <div v-if = "isEditing && community.communityPortal=='protopia'">
                                                                <div class="row" style="display: flex;">
                                                                    <div class="col-lg-2 col-sm-2 update-profile-response-label width100" aria-live="polite" style="width: auto; white-space: nowrap;">LinkedIn Url:</div>
                                                                    <div class="col-lg-10 col-sm-10">
                                                                        <md-field class="profileValidation">
                                                                            <md-input class="d-block-w-100 update-profile-template-input" aria-describedby="linkedIn-description" v-focus @input="saveChanges" v-model="memberObj.linkedIn" name="linkedIn" ></md-input>
                                                                            <div id="linkedIn-description" class="sr-only">
                                                                                Please enter your LinkedIn profile URL.
                                                                            </div>
                                                                        </md-field>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!--div class="btn-block">
                                                        <a v-if = "community.communityPortal=='customer'" v-bind:href="community.communitySite" v-bind:style="updateProfileBtn" v-focus target="_blank" class="btn btn-lightbg" @click="clickUpdateProfile(true)" id="update-profile-btn">Update</a>
                                                    </div>

                                                    <div class="btn-block">
                                                        <div>
                                                            <button type="button" v-focus v-if = "community.communityPortal=='protopia'" v-bind:style="updateProfileBtn" class="btn template-button btn-lightbg" :disabled="buttonToggle" @click="isEditing ? saveProfile('blank') : editProfile()" id="update-profile-btn">{{buttonToggle? "Saved!": "Update"}}</button>
                                                            <!-- <span v-if="buttonToggle" style="cursor: pointer; color: gray; margin-left: 5px;" @click="updateButtonToggle" class="refresh"><img src="../assets/refresh.png"></span> -->
                                                        <!--/div>
                                                    </div-->

                                                    <div class="btn-block">
                                                        <button type="button" v-focus v-if="community.communityPortal == 'linkedin'" @click="clickUpdateProfile(true),saveProfile('blank'), updateLinkedinProfile" class="btn linkedin-btn" >Update from LinkedIn</button>
                                                    </div>

                                                    <div class="btn-block">
                                                        <button type="button" v-bind:style="nextCloseBtn" class="btn template-button btn-lightbg" @click="goToNext()">Next</button>
                                                    </div>

                                                    <span class="h-54"></span>
                                                </div>
                                                <div v-show="isEmailSection">
                                                    <p class="my-text-center">Would you like to adjust how often we ask you for help with requests matching your profile?</p>
                                                    <div class="row">
                                                        <div class="col-md-12 text-center">
                                                            <div class="progressbar-block my">
                                                                <ul
                                                                    class="progressbar"
                                                                    role="radiogroup"
                                                                    aria-labelledby="email-frequency-label"
                                                                    aria-live="polite"
                                                                    @keydown="handleArrowKeys"
                                                                >
                                                                    <span id="email-frequency-label" class="sr-only">Select email frequency</span>
                                                                    <li
                                                                        :tabindex="adviser.frequency === 'as often as needed' ? 0 : -1"
                                                                        role="radio"
                                                                        @keydown.enter.space="changeEmailFrequency('as often as needed')"
                                                                        @click.stop="changeEmailFrequency('as often as needed')"
                                                                        v-bind:class="{'success': adviser.frequency == 'as often as needed'}"
                                                                        :aria-checked="adviser.frequency === 'as often as needed'">
                                                                        <div>All</div>
                                                                        <div v-if="frequency == 'as often as needed'" class="success-text">(active)</div>
                                                                    </li>
                                                                    <li
                                                                        :tabindex="adviser.frequency === 'daily' ? 0 : -1"
                                                                        role="radio"
                                                                        @keydown.enter.space="changeEmailFrequency('daily')"
                                                                        @click.stop="changeEmailFrequency('daily')"
                                                                        v-bind:class="{'success': adviser.frequency == 'daily'}"
                                                                        :aria-checked="adviser.frequency === 'daily'">
                                                                        <div>Daily</div>
                                                                        <div v-if="frequency == 'daily'" class="success-text">(active)</div>
                                                                    </li>
                                                                    <li
                                                                        :tabindex="adviser.frequency === 'once a week' ? 0 : -1"
                                                                        role="radio"
                                                                        @keydown.enter.space="changeEmailFrequency('once a week')"
                                                                        @click.stop="changeEmailFrequency('once a week')"
                                                                        v-bind:class="{'success': adviser.frequency == 'once a week'}"
                                                                        :aria-checked="adviser.frequency === 'once a week'">
                                                                        <div>Weekly</div>
                                                                        <div v-if="frequency == 'once a week'" class="success-text">(active)</div>
                                                                    </li>
                                                                    <li
                                                                        :tabindex="adviser.frequency === 'once a month' ? 0 : -1"
                                                                        role="radio"
                                                                        @keydown.enter.space="changeEmailFrequency('once a month')"
                                                                        @click.stop="changeEmailFrequency('once a month')"
                                                                        v-bind:class="{'success': adviser.frequency == 'once a month'}"
                                                                        :aria-checked="adviser.frequency === 'once a month'">
                                                                        <div>Monthly</div>
                                                                        <div v-if="frequency == 'once a month'" class="success-text">(active)</div>
                                                                    </li>
                                                                    <li
                                                                        :tabindex="adviser.frequency === 'once a quarter' ? 0 : -1"
                                                                        role="radio"
                                                                        @keydown.enter.space="changeEmailFrequency('once a quarter')"
                                                                        @click.stop="changeEmailFrequency('once a quarter')"
                                                                        v-bind:class="{'success': adviser.frequency == 'once a quarter'}"
                                                                        :aria-checked="adviser.frequency === 'once a quarter'">
                                                                        <div>Quarterly</div>
                                                                        <div v-if="frequency == 'once a quarter'" class="success-text">(active)</div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="btn-block">
                                                        <button type="button" tabindex="0" v-bind:style="emailBtn" @click="updateEmailFrequency()" class="btn template-button btn-darkbg mb_0">Submit</button>
                                                    </div>
                                                    <div class="btn-block">
                                                        <button tabindex="0" type="button" v-bind:style="nextCloseBtn" class="btn template-button btn-lightbg" @click="closeBtn()">Close</button>
                                                    </div>
                                                    <span class="h-54"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Refferal Form start -->
                                <div class="nofeedback" v-show="(successReferral === false && success === false && action === 'no' && (buttonText.search(/Not Available/i) !== -1 || buttonText.search(/Not Relevant/i) !== -1 || buttonText.search(/Not A Good Question/i) !== -1)  && (memberid != 'undefined' && typeof memberid != 'undefined' && memberid != 'null' && memberid != '') || ( skip == 'yes' && successReferral === false))">
                                    <form @submit.prevent="submitReferral('referral')" data-vv-scope="referral" v-if="buttonText.search(/Not Available/i) !== -1" class="template-form">
                                        <div class="row">
                                            <div class="col-sm-4 nofeedback-customspace">
                                                <div class="form-group">
                                                    <div>Recipient</div>
                                                </div>
                                            </div>
                                            <div class="col-sm-4 nofeedback-customspace mb-17">
                                                <div class="input-group">
                                                    <label class="template-label">Name</label>
                                                    <input ref="recipient_name" aria-describedby="recipient_name_error" type="text" class="form-control input-value" v-model.trim="referral.recipient.name" name="recipient_name" v-validate="'required'" v-focus @input="e => referral.recipient.name = sanitizeInput(e.target.value)">
                                                    <p class="error" id="recipient_name_error"  v-show="errors.has('referral.recipient_name')">{{errors.first('referral.recipient_name')}}</p>
                                                </div>
                                            </div>
                                            <div class="col-sm-4 nofeedback-customspace mb-17">
                                                <div class="input-group">
                                                    <label class="template-label">Email:</label>
                                                    <input ref="recipient_email" name="recipient_email" id="recipient_email" aria-describedby="recipient_email_error"  type="text" class="form-control input-value" v-model.trim="referral.recipient.email" v-validate="'required|email'" @input="e => referral.recipient.email = sanitizeInput(e.target.value)">
                                                    <p class="error" id="recipient_email_error" v-show="errors.has('referral.recipient_email')">{{errors.first('referral.recipient_email')}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-4 nofeedback-customspace ">
                                                <div class="form-group">
                                                    <div>Your Details</div>
                                                </div>
                                            </div>
                                            <div class="col-sm-4 nofeedback-customspace mb-17">
                                                <div class="input-group">
                                                    <label class="template-label" for="adviser_name">Name:</label>
                                                    <input  ref="adviser_name" id="adviser_name" type="text" class="form-control input-value" aria-describedby="name-instructions" v-model.trim="referral.adviser.name" name="adviser_name" v-validate="'required'" @input="e => referral.adviser.name = sanitizeInput(e.target.value)">
                                                    <span id="name-instructions" class="sr-only">Please enter your name</span>
                                                    <p class="error" v-show="errors.has('referral.adviser_name')">{{errors.first('referral.adviser_name')}}</p>
                                                </div>
                                            </div>
                                            <div class="col-sm-4 nofeedback-customspace mb-17">
                                                <div class="input-group">
                                                     <label class="template-label" for="adviser_email">Email:</label>
                                                    <input ref="adviser_email" id="adviser_email" type="text"  aria-describedby="email-instructions" class="form-control input-value" v-model.trim="referral.adviser.email" name="adviser_email" v-validate="'required|email'" @input="e => referral.adviser.email = sanitizeInput(e.target.value)">
                                                    <span id="email-instructions" class="sr-only">Please enter your email</span>
                                                    <p class="error" v-show="errors.has('referral.adviser_email')">{{errors.first('referral.adviser_email')}}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-4 nofeedback-customspace">
                                                <div class="form-group">
                                                    <div>Personal Message</div>
                                                </div>
                                            </div>
                                            <div class="col-sm-8">
                                                <div class="input-group">
                                                    <label class="template-label">Message<span class="required-symbol"> *</span></label>
                                                    <div class="template-input-text-area common-question-textarea-for-v1-v2 unsubscribe-height">
                                                        <textarea
                                                            class="form-control"
                                                            v-model="referral.message"
                                                            v-on:keyup="countdownReferral"
                                                            aria-label="Enter your personal message to the referral"
                                                            rows="7"
                                                            aria-required="true"
                                                            required
                                                            :maxlength="maxReferral"
                                                            name="message"
                                                            v-validate="'required|max:500'"
                                                            @input="e => referral.message = sanitizeInput(e.target.value)"
                                                            placeholder="[Click here to edit]
    I help students and alumni...">
                                                        </textarea>
                                                        <p class="error" v-show="errors.has('referral.message')">{{errors.first('referral.message')}}</p>
                                                        <div class="form-group pd-remove unsubscribe-btn mb-0-custom">
                                                            <div
                                                                class="char-counter template-subject-counter"
                                                                v-bind:class="{'char-count-error': exceedsMaxCountReferral }"
                                                            >{{remainingCountReferral}}  / 500
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="contactInfoDetected === false"
                                                        class="contact-detection-banner">
                                                        <span class="contact-detection-icon">!</span>
                                                        <div class="contact-detection-text">
                                                            <strong>No contact information detected</strong>
                                                            <p>Make it easy for people to connect with you: add your email, phone number, or scheduling link!</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-12 col-sm-12 text-right">
                                                        <button type="submit" v-bind:style="styleObjectBtn" class="btn template-button submitBtn">Share Request</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-4"></div>
                                        <div class="col-sm-8">
                                        </div>
                                    </form>
                                </div>
                                <!-- Refferal Form end -->
                                <!-- Requester Detail section -->

                                <div v-if="((success === false && successReferral == false && buttonText.search(/Not A Good Question/i) == -1) || (success && successReferral == false && action == 'no' && buttonText.search(/Not A Good Question/i) == -1 && (memberid != 'undefined' && typeof memberid != 'undefined' && memberid != 'null' && memberid != '')))">
                                    <!--<div class="media-left media-middle">
                                        <img v-if="createdByMember && createdByMember.imageURL" :src="createdByMember.imageURL" alt="Member photo" class="media-object email-circle-image">
                                        <img v-if="!createdByMember || !createdByMember.imageURL" src="../assets/person.png" alt="Member photo" class="media-object email-circle-image">
                                    </div>-->
                                    <div class="row my" v-if="!termsAndConditions || action == 'no'">
                                        <div class="col-md-12">
                                            <h1 class="text-center email-request-title">FYI, here's the request</h1>
                                        </div>
                                    </div>
                                    <div class="row my" v-if="termsAndConditions && action == 'yes'">
                                        <div class="col-md-12">
                                            <div class="form-group disclaimer terms-conditions-box">
                                                    <md-checkbox name="checkedTerms" id="checkedTerms" @input="saveChanges" class="form-control template-checkbox pt-0" v-model="checkedTerms"></md-checkbox>
                                                    <label class="html-disclaimer" for="checkedTerms" v-html="community.content.termsAndConditionsMessage"></label>
                                            </div>
                                            <p class="terms-error" v-if="showTermsErrorMsg">Please acknowledge that you have read our terms and conditions before proceeding.</p>
                                        </div>
                                    </div>
                                    <div class="email-request-review">
                                        <div class="template-request-review">
                                            <h2 v-if="createdByMember.first && createdByMember.last">{{ createdByMember.first + ' ' +  createdByMember.last }}</h2>
                                            <span v-if="memberSchool" class="email-custom">{{ memberSchool }}</span>
                                            <h3>{{ask.subject}}</h3>
                                            <p class="font-color">{{ask.text}}</p>
                                        </div>
                                    </div>
                                </div>
                                <!-- Requester Detail section -->
                            </div>
                        </div>
                        <ul class="list-inline text-center footer-links">
                            <li>
                                <a tabindex="0" :href="community.content.landingPageURL" target="_blank" class="links" v-if="community.content && community.content.landingPageURL && community.content.landingPageURL.length">Learn More</a>
                                <a href="javascript:void(0)" tabindex="0" v-else>Learn More</a>
                            </li>
                            <li>
                                <a tabinex="0" :href="community.content.termsConditionsURL" target="_blank" class="links" v-if="community.content && community.content.termsConditionsURL && community.content.termsConditionsURL.length">Terms Of Use [pdf]</a>
                                <a href="javascript:void(0)" v-else tabindex="0">Terms Of Use [pdf]</a>
                            </li>
                            <li>
                                <a tabindex="0" :href="community.content.unsubscribePageURL" target="_blank" v-if="community.content && community.content.unsubscribePageURL && community.content.unsubscribePageURL.length">Opt Out</a>
                                <a href="javascript:void(0)" v-else>Opt Out</a>
                            </li>
                        </ul>
                        <div class="unsubscribe-community-logo email-actionpage-flogo">
                            <a href="https://www.protopia.co" target="_blank"><img :src="footerLogoURL" :alt="'Community Logo of '+ community.content.parameter2"></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <custom-action :memberid="memberid" :askid="askid" :action="action" :skip="skip" :actionPageType="actionPageType" v-else></custom-action>
    </main>
</template>
<script>
import API from "../services/API";
import Snackbar from 'vuejs-snackbar';
import CustomAction from "./CustomAction.vue";
import { sanitizeInput, sanitizeUrl, sanitizeHtmlTemplate, sanitizeResourceDescription, decodeHtmlEntitiesForPlainText } from '../utils/sanitizer';
import EventBus from '../assets/js/EventBus';
import { getFooterURL, getLogoURL } from "../helpers/getCustomSettings";

export default {
  props: ["communityId", "memberid", "askid", "action", "skip"],
  components: {Snackbar, CustomAction},
  data() {
    return {
      contactInfoDetected: null,
      detectionTimeout: null,
      phoneInput: "",
      currentTab: "",
      infoHasChanged: false,
      api: new API(),
      ask: {},
      community: {},
      circleId: "",
      createdByMember: {},
      feedback_comment: "",
      feedback_comment2: "",
      action_taken: "",
      error: "none",
      checked: "",
      feedback: "none",
      success: false,
      successMsg: "",
      isEmailSection: false,
      opened: [],
      buttonText: '',
      first: '',
      last: '',
      email: '',
      fullPage: true,
      exceedsMaxCount: false,
      max: 5000,
      remainingCountCall: 0,
      remainingCountAdvice: 0,
          remainingCountConnect: 0,
          remainingCount: 0,
            referral: {
                recipient: {
                    name: '',
                    email: ''
                },
                adviser: {
                    name: '',
            email: ''
      },
      message: "I'm trying to help out someone from {{ community.name }} and thought of you - are you able to help? If so, just click below to respond directly."
    },
    adviser: {},
    exceedsMaxCountReferral: false,
    maxReferral: 500,
    remainingCountReferral: 0,
    successReferral: false,
    giveId: '',
    phoneNo: '',
    showAdvisorFrequncy: true,
    selectedResponse: '',
    isExpanded: false,
    responsesArr: ["Not a question", "Not clear", "Not enough information", "Poorly phrased", "Too long", "Unprofessional"],
    styleBtn: {
      colorBackd: '#CBA8E0',
      colorBackdHover: '#9178A0',
      color: '#9178A0',
      colorHover: "#ffffff",
      colorLightGray: "#CCCCCC"
    },
    reviewBtn: {
      border: '1px solid #9178A0',
      color: '#9178A0'
    },
    textError: false,
    memberRoles: '',
    memberskills: '',
    emailUpdate: false,
    isProfileValidation: false,
    // updateProfileBtn: {
    //   background: '#CBA8E0',
    //   color: '#ffffff'
    // },
    emailBtn: {
      background: '#9178A0',
      color: '#ffffff'
    },
    frequency: '',
    memberObj: {},
            isEditing: true,
            footerLogoURL: "",
            advisorThankYou: '',
            isStatus: true,
            statusMsg: '',
            logoURL: "",
            callText: false,
            callMessage: '',
            requestGiveId: '',
            isSubmitBtnDisabled: false,
            referanceInterest: [],
            randomInterest: [],
            memberInterestList: [],
            selectedInterestList: [],
            configureFields: {},
            isUpdateProfileFlag: true,
            enableProfileUpdateList: [],
            termsAndConditions: false,
            checkedTerms: false,
    showTermsErrorMsg: false,
    actionPageType: '',
    buttonStates: {
      shareAdvice: false,
      callMe: false,
      letsConnect: false
    },
    loaded: false,
    buttonToggle: false,
    memberSchool: '',
    referralMember: null
  };
  },
  directives: {
    'click-outside': {
      bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a  function, but has to be`
          if (compName) { warn += `Found in component '${compName}'` }
          console.warn(warn)
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        // add Event Listeners
        document.addEventListener('click', handler)
      },
      unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  },
  watch: {
    $route: function(to, from) {
      this.opened = [];
    },
    "action": function(newVal, oldVal) {
      if (oldVal === 'no' && newVal === 'yes') {
        // this.updateActions();
      }
    }
  },
  computed: {
    styleObjectBtn() {
      return {
        '--styleBtn-color': this.styleBtn.color,
        '--styleBtn-background-color': this.styleBtn.colorBackd,
        '--styleBtn-color--hover': this.styleBtn.colorHover,
        '--styleBtn-background-color--hover': this.styleBtn.colorBackdHover
      };
    },
    submitStyleObjectBtn() {
      return {
        'color': this.styleBtn.color,
        'background-color': this.styleBtn.colorBackd,
        'color:hover': this.styleBtn.colorHover,
        'background-color:hover': this.styleBtn.colorBackdHover
      };
    },
    updateProfileBtn() {
      return {
        'color': this.styleBtn.colorHover,
        'background-color': this.styleBtn.colorBackdHover
        // 'margin-left': this.buttonToggle ? "30px" : ""
        // '--styleBtn-color': this.styleBtn.color,
        // '--styleBtn-background-color': this.styleBtn.colorBackd,
        // '--styleBtn-color--hover': this.styleBtn.colorHover,
        // '--styleBtn-background-color--hover': this.styleBtn.colorBackdHover
      };
    },
    nextCloseBtn() {
      return {
        'color': this.styleBtn.color,
        'background-color': this.styleBtn.colorBackd,
        'border': `1px solid ${this.styleBtn.color}`
      };
    }
  },
  created() {
    if (!this.askid || !this.action) {
      this.$router.push('/');
    }
    this.loadData();
    const dict = {
      custom: {
        feedback_first: {
          required: 'Your first name is required before you can respond. Thank You.',
          alpha_spaces: 'Only alphabetic characters are allowed in this field'
        },
        feedback_last: {
          required: 'Your last name is required before you can respond. Thank You.',
          alpha_spaces: 'Only alphabetic characters are allowed in this field'
        },
        feedback_email: {
          required: 'Your email address is required before you can respond. Thank You.',
          email: 'Please enter a valid email address',
          max: 'Email address may not be greater than 60 characters'
        },
    		    feedback_comment: {
    		      required: 'Please enter your advice',
                  min: 'Please personalize and expand your response (minimum 50 characters)'
                },
                feedback_comment2: {
    		      required: 'Please enter a message',
                  min: 'Please personalize and expand your response (minimum 25 characters)'
                },
                phoneNo: {
                    required: 'Please enter a phone number',
                    numeric: 'The phone number field may only contain numeric characters.'
                },
                "call-message": {
    		        required: 'Please enter a message',
                    min: 'Please personalize and expand your response (minimum 25 characters)'
                }
    		 }
    	  };
    		this.$validator.localize('en', dict);
    		const dict1 = {
    			custom: {
    				recipient_name: {
    					required: "Please enter a name"
    				},
    				recipient_email: {
    					required: "Please enter an email",
    					email: "Please enter a valid email"
    				},
    				adviser_name: {
    					required: "Please enter a name"
    				},
    				adviser_email: {
    					required: "Please enter an email",
    					email: "Please enter a valid email"
    				},
    				message: {
    					required: "Please enter a message"
    				}
    			}
    		};
    		this.$validator.localize('en', dict1);
    },
    methods: {
        detectContactInfo(message) {
            if (!message || message.trim().length < 20) {
                this.contactInfoDetected = null;
                return;
            }
            clearTimeout(this.detectionTimeout);
            this.detectionTimeout = setTimeout(() => {
                this._callContactDetection(message);
            }, 400);
        },

        _callContactDetection(message) {
            const trimmed = message.trim();
            const sample = trimmed.length <= 800
                ? trimmed
                : trimmed.slice(0, 400) + '\n' + trimmed.slice(-400);
            this.api.post('asks/contact-detection', { message: sample })
                .then((response) => {
                    this.contactInfoDetected = response.data.detected !== undefined ? response.data.detected : null;
                })
                .catch((err) => {
                    console.error('Contact detection error:', err);
                    this.contactInfoDetected = null;
                });
        },
        sanitizeInput(input) {
            return sanitizeInput(input);
        },
        sanitizeUrl(url) {
            return sanitizeUrl(url);
        },
        sanitizeHtmlTemplate(template) {
            return sanitizeHtmlTemplate(template);
        },
        sanitizeResourceDescription(description) {
            return sanitizeResourceDescription(description);
        },
        actionFormTipsPlaceholder(tips) {
            return decodeHtmlEntitiesForPlainText(tips || '');
        },
          loadData: async function () {
              this.advisorThankYou = '';
              localStorage.setItem('community_id', this.communityId);
              await this.$nextTick(); // Ensure localStorage is committed before API calls
              await this.api.get(`asks/${this.askid}`).then(async ask => {
                  this.ask = ask.data;
                  this.ask.text = this.ask.text.replace(/\n{1,}/g, '\n\n');
                  if (this.ask) {
                      this.circleId = this.$route.query.circle ? this.$route.query.circle : this.ask.sourceparam;
                    if (this.ask.status === '(8) Rejected' || this.ask.status === '(7) Closed') {
                        // console.log("this.community :", this.ask.community);
                        let closeMessage = this.ask.community.content.closeRequestMessage;
                        this.statusMsg = closeMessage;
        			} else {
                        this.isStatus = false;
                    }
                    this.community = this.ask.community;
                    if (this.community.customSettings && this.community.customSettings.faviconURL !== 'none') {
                        console.log('EmailRequest: Emitting favicon change', this.community.customSettings.faviconURL);
                        EventBus.$emit('change-favicon', this.community.customSettings.faviconURL);
                    }
                    const customSettings = this.community.customSettings;
                    document.title = this.community.name + " | Accept or Decline a Request";
                    this.logoURL = getLogoURL(customSettings);
                    this.footerLogoURL = getFooterURL(customSettings);
                    this.configureFields = this.community.content.configureFields;
                    this.enableProfileUpdateList.push(this.configureFields.profileUpdateOccupation);
                    this.enableProfileUpdateList.push(this.configureFields.profileUpdateInterest);
                    this.enableProfileUpdateList.push(this.configureFields.profileUpdateGeography);
                    this.enableProfileUpdateList.push(this.configureFields.profileUpdatePhoneNumber);
                    this.enableProfileUpdateList.push(this.configureFields.profileUpdateLinkedInUrl);
                    this.enableProfileUpdateList = this.enableProfileUpdateList.sort();
                    this.enableProfileUpdateList = this.enableProfileUpdateList.filter(e => e !== 0)
                    if (this.configureFields.profileUpdateOccupation == 0 && this.configureFields.profileUpdateInterest == 0 && this.configureFields.profileUpdateGeography == 0 &&
                    this.configureFields.profileUpdatePhoneNumber == 0 && this.configureFields.profileUpdateLinkedInUrl == 0) {
                        this.isUpdateProfileFlag = false;
                        this.isEmailSection = true;
                    }
                    this.isProfileValidation = this.ask.community.content.profileValidation;
                    this.styleBtn.colorBackdHover = customSettings.primaryBtnBgColor;
                    this.styleBtn.colorHover = customSettings.primaryTxtColor;
                    this.styleBtn.colorBackd = customSettings.secondaryBtnBgColor;
                    this.styleBtn.color = customSettings.secondaryTxtColor;
                    this.reviewBtn = {
                        border: '1px solid ' + customSettings.primaryBtnBgColor,
                        color: customSettings.primaryBtnBgColor
                    };
                    // this.updateProfileBtn = {
                    //     background: customSettings.secondaryBtnBgColor,
                    //     color: customSettings.secondaryTxtColor
                    // }
                    this.emailBtn = {
                        background: customSettings.primaryBtnBgColor,
                        color: customSettings.primaryTxtColor
                    }
                    if (this.community.content.advisorThankYou) {
                        this.advisorThankYou = this.community.content.advisorThankYou;
                    }
                    this.replaceMessage();
                    if (this.memberid != 'undefined' && typeof this.memberid != 'undefined' && this.memberid != 'null' && this.memberid != '') {
                        await this.api.get(`members/${this.memberid}`).then(member => {
                            this.adviser = member.data;
                            if (this.community.content && this.community.content && this.community.content.termsAndConditions == true && !this.adviser.termsAccepted) {
                                this.termsAndConditions = true;
                            }
                            this.memberObj = member.data;
                            console.log(this.memberObj);
                            this.phoneInput = Array.isArray(this.memberObj.phoneNumbers)
                                ? (this.memberObj.phoneNumbers[0] || "")
                                : "";
                            this.memberObj.memberRoles = this.memberRoles;
                            this.memberObj.memberskills = this.memberskills;
                            this.frequency = member.data.frequency;
                            if (this.community.content && this.community.content.configureFields && this.community.content.configureFields.interest && this.community.content.configureFields.interest.include === false) {
                                if (this.adviser.profileValidationFlag == this.configureFields.profileUpdateInterest) {
                                    if (this.adviser.profileValidationFlag < 5) {
                                        this.adviser.profileValidationFlag = this.adviser.profileValidationFlag + 1;
                                    } else {
                                        this.adviser.profileValidationFlag = 1;
                                    }
                                }
                                if (this.enableProfileUpdateList.includes(this.configureFields.profileUpdateInterest)) {
                                    this.enableProfileUpdateList = this.enableProfileUpdateList.filter(e => e !== this.configureFields.profileUpdateInterest);
                                }
                            }
                            if (this.enableProfileUpdateList.length > 0) {
                                if (this.enableProfileUpdateList.length == 1) {
                                    this.adviser.profileValidationFlag = this.enableProfileUpdateList[0];
                                } else if (!this.enableProfileUpdateList.includes(this.adviser.profileValidationFlag)) {
                                    if (this.adviser.profileValidationFlag == 5) {
                                        this.adviser.profileValidationFlag = 1;
                                        if (!this.enableProfileUpdateList.includes(this.adviser.profileValidationFlag)) {
                                            this.adviser.profileValidationFlag = this.nextElement(this.enableProfileUpdateList, this.adviser.profileValidationFlag)
                                        }
                                    } else {
                                        this.adviser.profileValidationFlag = this.nextElement(this.enableProfileUpdateList, this.adviser.profileValidationFlag);
                                    }
                                }
                            }
                            if (this.adviser && this.adviser.profileValidationFlag == this.configureFields.profileUpdateInterest) {
                                this.isEditing = true;
                            }
                            if (this.adviser && (this.adviser.profileValidationFlag != this.configureFields.profileUpdateInterest && this.adviser.profileValidationFlag != this.configureFields.profileUpdateOccupation && this.adviser.profileValidationFlag != this.configureFields.profileUpdateGeography &&
                            this.adviser.profileValidationFlag != this.configureFields.profileUpdatePhoneNumber && this.adviser.profileValidationFlag != this.configureFields.profileUpdateLinkedInUrl)) {
                                this.isUpdateProfileFlag = false;
                                this.isEmailSection = true;
                            }
                            if (member.data.roles && member.data.roles.length > 0) {
                                this.memberObj.memberRoles = member.data.roles.toString();
                            }
                            if (member.data.skills && member.data.skills.length > 0) {
                                this.memberObj.memberskills = member.data.skills.toString();
                            }
                            if (member.data && member.data.first && member.data.last) {
                                this.referral.adviser.name = `${member.data.first} ${member.data.last}`;
                            }
                            this.referral.adviser.email = member.data && member.data.emails && member.data.emails.length ? member.data.emails[0].toLowerCase().trim() : '';
                            if (this.referral && this.referral.message && this.referral.message.length && this.maxReferral) {
                                this.remainingCountReferral = this.maxReferral - this.referral.message.length;
                            }
                        });
                        let actionEvent = '';
                        let quertData = '';
                        if (this.$route.query.action === "share") {
                            this.expandContent('no', 'Not Available')
                        }
                        if (this.$route.query.respond) {
                            actionEvent = 'MemberRespond';
                            quertData = 'respond';
                        } else if (this.$route.query.pass) {
                            actionEvent = 'MemberPassRequest';
                            quertData = 'pass';
                        }
                        if (actionEvent) {
                            this.$gtm.enable(true)
                            this.$gtm.trackEvent({
                                'RequestID': this.ask._id,
                                'RequestSource': 'Web',
                                'RequestReceived': this.$moment(this.ask.createdAt).tz("America/New_York").format('YYYYMMDD'),
                                'Community': this.ask.community.name,
                                'Circle': this.circleId,
                                'MemberID': this.memberid,
                                'MemberRole': 'Advisor',
                                'event': actionEvent
                            });
                            var newRouteQuery = this.$lodash.omit(this.$route.query, quertData);
                            this.$router.replace({ query: newRouteQuery });
                        }
                        // this.memberInterestList = this.memberObj.interests;
                        let mergedInterest = [];
                        this.api.get(`configuration/customizations/interests?community=${this.community._id}&circle=${this.circleId}`).then(interests => {
                            // if (this.memberInterestList) {
                                this.memberInterestList = new Map(this.memberInterestList.map(s => [s.toLowerCase(), s]));
                                this.memberInterestList = [...this.memberInterestList.values()];
                            // }
                            let refInterest = interests.data.values;
                            var referanceInterestArr = [];
                            if (typeof refInterest != 'undefined' && refInterest.length) {
                                mergedInterest = referanceInterestArr = this.referanceInterest = refInterest;
                            }
                            // if (this.memberInterestList) {
                                var memberRefrenceInterest = referanceInterestArr;
                                mergedInterest = new Map(memberRefrenceInterest.map(s => [s.toLowerCase(), s]));
                            // }
                            mergedInterest = [...mergedInterest.values()];
                            const n = process.env.RANDOM_INTEREST_COUNT;
                            var shuffled = mergedInterest.sort(function() { return 0.5 - Math.random(); });
                            this.randomInterest = shuffled.slice(0, n);
                        });
                    }
                    this.createdByMember = this.ask.createdByMemberID;
                    this.findMemberSchool(this.createdByMember._id);
                    this.actionPageType = this.ask.actionPage && this.ask.actionPage !== undefined && this.ask.actionPage !== null ? this.ask.actionPage : 'defPage';
                    if (this.action == 'yes') {
                        setTimeout(function () {
                            if (this.actionPageType === 'defPage') {
                                document.getElementById("shareAdviceBtn").focus();
                            }
                        }, 100);
                    }
                }
                if (this.action === 'no') {
                    let parameters = {};
                    if (this.memberid === 'undefined' || typeof this.memberid === 'undefined' || this.memberid === '' || this.memberid === 'null' || this.memberid === null) {
                        parameters = {
                            action: "N/A",
                            email: this.email ? this.email.toLowerCase() : '',
                            help: 'request-help',
                            helpaction: this.action
                        };
                        if (this.$route.query.referralid) {
                            parameters.helpactionType = 'referral';
                            parameters.referralid = this.$route.query.referralid;
                        }
                    } else {
                        parameters = {
                            advisors: [this.memberid],
                            action: this.$route.query.action === "share" ? 'Not Available' : "N/A",
                            help: 'request-help',
                            helpaction: this.action
                        };
                        if (this.$route.query.referralid) {
                            parameters.helpactionType = 'referral';
                            parameters.referralid = this.$route.query.referralid;
                        }
                    }
                    this.api
                    .post(`asks/${this.ask._id}/request-help`, parameters)
                    .then(response => {
                        setTimeout(function () {
                            document.getElementById("notAvailableBtn").focus();
                        }, 100);
                        if (response.data.giveId) {
                            this.giveId = response.data.giveId;
                            this.requestGiveId = response.data.giveId;
                        }
                    });
                }
                this.loaded = true;
            }).catch((err) => {
              this.statusMsg = "We're sorry something went wrong.  We can't find this request.";
              console.log(err);
            });
        },
        handleArrowKeys(event) {
      const listItems = this.$el.querySelectorAll('li');
      let index = Array.from(listItems).findIndex(item => item === document.activeElement);

      if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
        index = (index + 1) % listItems.length;
        listItems[index].focus();
      } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
        index = (index - 1 + listItems.length) % listItems.length;
        listItems[index].focus();
      }
    	},
        changeEmailFrequency(frequency) {
            this.adviser.frequency = frequency;
        },
        saveChanges: function() {
            this.infoHasChanged = true;
        },
        async updateEmailFrequency() {
            document.title = 'Thank You';
            this.successMsg = "Thank you!";
            if (this.ask.status !== '(8) Rejected' && this.ask.status !== '(7) Closed') {
                window.scrollTo(0, 0);
                this.api.post(`members/${this.memberid}/update-email-frequency`, {frequency: this.adviser.frequency})
                .then(response => {
                    let frequency = '';
                    if (this.adviser.frequency === 'as often as needed') {
                        frequency = 'All';
                    } else if (this.adviser.frequency === 'daily') {
                        frequency = 'Daily';
                    } else if (this.adviser.frequency === 'once a week') {
                        frequency = 'Weekly';
                    } else if (this.adviser.frequency === 'once a month') {
                        frequency = 'Monthly';
                    } else if (this.adviser.frequency === 'once a quarter') {
                        frequency = 'Quarterly';
                    }
                    if (typeof this.memberid !== 'undefined' && this.memberid !== 'null' && frequency) {
                        this.$gtm.enable(true)
                        this.$gtm.trackEvent({
                            'RequestID': this.ask._id,
                            'RequestSource': 'Web',
                            'RequestReceived': this.$moment(this.ask.createdAt).tz("America/New_York").format('YYYYMMDD'),
                            'Community': this.ask.community.name,
                            'Circle': this.circleId,
                            'MemberID': this.memberid,
                            'MemberRole': 'Advisor',
                            'AskFrequency': frequency,
                            'event': 'MemberAdjustAskFrequency'
                        });
                    }
                });
                if (this.advisorThankYou) {
                    window.open(this.advisorThankYou, '_self');
                } else {
                    this.emailUpdate = true;
                }
            } else {
                let status = 'reject';
                if (this.ask.status === '(7) Closed') {
                    status = 'close';
                }
                this.$toast.error(`Request is ${status} so you can't not add response`);
            }
        },
        getCookie(name) {
            let matches = document.cookie.match(new RegExp(name + '=([^;]+)'));
            return matches ? decodeURIComponent(matches[1]) : undefined;
        },
        updateLinkedinProfile() {
             var memberUpdateData = {
                requestId: this.ask._id,
                giveId: this.requestGiveId,
                communityId: this.community._id,
                community: this.community.name,
                memberId: this.adviser._id,
                propertyId: this.adviser.propertyId,
                name: this.adviser.displayName && (typeof this.adviser.displayName !== 'undefined' || this.adviser.displayName !== '') ? this.adviser.displayName : this.adviser.first + ' ' + this.adviser.last,
                email: this.adviser.emails.toString(),
                communityCustomSettings: this.community.customSettings,
                communityContentParameter2: this.community.content.parameter2,
                communityContentLandingPageURL: this.community.content.landingPageURL,
                communityContentTermsConditionsURL: this.community.content.termsConditionsURL,
                communityContentUnsubscribePageURL: this.community.content.unsubscribePageURL
            };

            if (this.getCookie("memberUpdateData")) {
                document.cookie = "memberUpdateData=" + JSON.stringify(memberUpdateData) + "; expires=Thu, 01 Jan 1970 00:00:00 GMT";
            }
            let clientId = this.community.linkedinCredentials && this.community.linkedinCredentials.clientId ? this.community.linkedinCredentials.clientId : process.env.LINKEDIN_CLIENT_ID
            let linkedInRedirectURI = process.env.LINKEDIN_REDIRECT_URI;
            let linkedInStateKey = process.env.LINKEDIN_STATE_KEY;

            document.cookie = "memberUpdateData=" + JSON.stringify(memberUpdateData) + ";expires=" + (new Date(this.$moment().utc().add(5, 'minutes').toDate())).toUTCString() + ";path=/";

            window.location.href = `https://www.linkedin.com/oauth/v2/authorization/?response_type=code&client_id=${clientId}&redirect_uri=${linkedInRedirectURI}&state=${linkedInStateKey}&scope=r_liteprofile%20r_emailaddress`;
        },
        helpaction(actionTaken) {
            const dict = {
    				custom: {
                        feedback_first: {
							required: 'Your first name is required before you can respond. Thank You.',
                            alpha_spaces: 'Only alphabetic characters are allowed in this field'
						},
                        feedback_last: {
							required: 'Your last name is required before you can respond. Thank You.',
                            alpha_spaces: 'Only alphabetic characters are allowed in this field'
						},
						feedback_email: {
							required: 'Your email address is required before you can respond. Thank You.',
							email: 'Please enter a valid email address',
							max: 'Email address may not be greater than 60 characters'
						}
    				}
    			};
    			this.$validator.localize('en', dict);
    			this.$validator.validateAll().then(async result => {
                if (result) {
    	      	  let parameters = {};
                  window.scrollTo(0, 0);
    		      // Save feeedback
                    if (this.action === 'yes') {
                        if (this.memberid === 'undefined' || typeof this.memberid === 'undefined' || this.memberid === '' || this.memberid === 'null' || this.memberid === null) {
                            this.referralMember = await this.createReferralMember(this.first, this.last, this.email, this.community._id, this.circleId);
                            parameters = {
                                advisors: [this.referralMember],
                                action: actionTaken.trim(),
                                help: 'request-help',
                                helpaction: this.action
                            }

                            if (actionTaken.search(/Share Advice/i) !== -1) {
                                parameters.insight = this.feedback_comment.trim();
                            } else if (actionTaken.search(/Let's connect/i) !== -1) {
                                parameters.insight = this.feedback_comment2.trim();
                            } else if (actionTaken.search(/Call Me/i) !== -1) {
                                let callMessage = this.callMessage ? `${this.callMessage}` : '';
                                parameters.insight = this.phoneNo
                                    ? `${callMessage} \n My phone number is: ${this.phoneNo}`
                                    : callMessage;
                            }
                            if (this.$route.query.referralid) {
                                parameters.helpactionType = 'referral';
                                parameters.referralid = this.$route.query.referralid;
                            }

                            parameters.giveId = this.giveId ? this.giveId : undefined;

                        } else {
                            parameters = {
                                advisors: [this.memberid],
                                action: actionTaken.trim(),
                                help: 'request-help',
                                helpaction: this.action
                            }

                            if (actionTaken.search(/Share Advice/i) !== -1) {
                                parameters.insight = this.feedback_comment.trim();
                            } else if (actionTaken.search(/Let's connect/i) !== -1) {
                                parameters.insight = this.feedback_comment2.trim();
                            } else if (actionTaken.search(/Call Me/i) !== -1) {
                                let callMessage = this.callMessage ? `${this.callMessage}` : '';
                                parameters.insight = this.phoneNo
                                    ? `${callMessage} \n My phone number is: ${this.phoneNo}`
                                    : callMessage;
                            }
                            if (this.$route.query.referralid) {
                                parameters.helpactionType = 'referral';
                                parameters.referralid = this.$route.query.referralid;
                            }
                            parameters.giveId = this.giveId ? this.giveId : undefined;
                        }
    					parameters.phoneNo = this.phoneNo;
                        parameters.calltext = this.callText;
                        parameters.callMessage = this.sanitizeInput(this.callMessage);
                        parameters.profileUpdateFlag = this.adviser.profileValidationFlag;

                        if (typeof this.memberid !== 'undefined' && this.memberid !== 'null') {
                            if (this.isUpdateProfileFlag) {
                                document.title = 'Update Your Information';
                                this.successMsg = "Thank You!"
                            } else {
                                document.title = this.community.name + " | Thank You";
                            }
                            this.success = true;
                            if (this.adviser.profileValidationFlag == this.configureFields.profileUpdateInterest) {
                                this.isEditing = true;
                            }
                            /*if (this.isUpdateProfileFlag) {
                                setTimeout(function () {
                                    document.getElementById("update-profile-btn").focus();
                                }, 500);
                            }*/
                            let submitEvent = '';
                            if (actionTaken.search(/Share Advice/i) === 0) {
                                submitEvent = 'MemberSubmitAdvice';
                            } else if (actionTaken.search(/Call Me/i) === 0) {
                                submitEvent = 'MemberSubmitPhone';
                            } else if (actionTaken.search(/Let's connect/i) === 0) {
                                submitEvent = 'MemberSubmitConnect';
                            }
                            if (submitEvent) {
                                this.$gtm.enable(true)
                                this.$gtm.trackEvent({
                                    'RequestID': this.ask._id,
                                    'RequestSource': 'Web',
                                    'RequestReceived': this.$moment(this.ask.createdAt).tz("America/New_York").format('YYYYMMDD'),
                                    'Community': this.ask.community.name,
                                    'Circle': this.circleId,
                                    'MemberID': this.memberid,
                                    'MemberRole': 'Advisor',
                                    'event': submitEvent
                                });
                            }
                        } else {
                            if (this.advisorThankYou) {
                                window.open(this.advisorThankYou, '_self');
                            } else {
                                document.title = 'Thank You';
                                this.success = true;
                            }
                        }
                        window.scrollTo(0, 0);
                        parameters.isTermsChecked = this.checkedTerms;
                        await this.api.post(`asks/${this.ask._id}/request-help`, parameters).then(response => {
                            if (response.data.giveId) {
                                this.requestGiveId = response.data.giveId;
                            }
    			        });
    			  } else {
    			  		let parameters = {};
    			  		if (this.action === 'no' && this.memberid === 'undefined' || this.action === 'no' && typeof this.memberid === 'undefined' || this.memberid === '' || this.memberid === 'null' || this.memberid === null) {
    			  			parameters = {
    				        	action: actionTaken.trim(),
                                first: this.sanitizeInput(this.first),
                                last: this.sanitizeInput(this.last),
    				        	email: this.sanitizeInput(this.email),
    				        	help: 'request-help',
                                helpaction: this.action,
                                giveId: this.giveId
                              };
                              if (this.$route.query.referralid) {
                                parameters.helpactionType = 'referral';
                                parameters.referralid = this.$route.query.referralid;
                              }
    			  		} else {
    			  			parameters = {
    			  				advisors: [this.memberid],
    				        	action: actionTaken.trim(),
    				        	help: 'request-help',
    				        	helpaction: this.action,
                                giveId: this.giveId
                              };
                              if (this.$route.query.referralid) {
                                parameters.helpactionType = 'referral';
                                parameters.referralid = this.$route.query.referralid;
                              }
    					}
                        parameters.profileUpdateFlag = this.adviser.profileValidationFlag;
    					if (actionTaken.search(/Not Available/i) !== -1 || actionTaken.search(/Not Relevant/i) !== -1) {
                            //window.scrollTo(0, 0);
                             if (this.action === 'no' && this.memberid === 'undefined' || this.action === 'no' && typeof this.memberid === 'undefined' || this.memberid === '' || this.memberid === 'null' || this.memberid === null) {
                                if (this.advisorThankYou) {
                                    window.open(this.advisorThankYou, '_self');
                                } else {
                                    document.title = 'Thank You';
                                    this.success = true;
                                }
                            }
                            parameters.isTermsChecked = this.checkedTerms;
                            await this.api.post(`asks/${this.ask._id}/request-help`, parameters).then(response => {
                                if (response.data.giveId) {
                                    this.giveId = response.data.giveId;
                                    this.requestGiveId = response.data.giveId;
                                }
                            });
                        }
                        if (actionTaken.search(/Not A Good question/i) !== -1) {
                            this.submitNegativeResponse(actionTaken, this.selectedResponse);
                        }
    			    }
                } else {
                    let errorElements = document.querySelectorAll('.error');
                    if (errorElements.length > 0) {
                        for (let errorElement of errorElements) {
                            let message = '';
                            message = errorElement.innerText;
                            this.errorAnnouncement(message);
                        }
                    }
                }
                if (this.adviser && this.adviser.profileValidationFlag == this.configureFields.profileUpdateInterest) {
                    this.isEditing = true;
                }
    	    });
        },
        errorAnnouncement(message) {
          const liveRegion = document.createElement('div');
          liveRegion.setAttribute('aria-live', 'polite');
          liveRegion.setAttribute('role', 'alert');
          liveRegion.innerText = message;
          document.body.appendChild(liveRegion);
          setTimeout(() => {
            liveRegion.remove();
          },1000);
        },
        validate() {
          if (!this.feedback_comment.trim().length) {
            this.error = "block";
            return false;
          }
          this.error = "hidden";
        },
        expandContent(id, value) {
            let openedSection = true;
            this.showTermsErrorMsg = false;
            if (id == 'yes' && this.termsAndConditions && !this.checkedTerms) {
                openedSection = false;
                this.showTermsErrorMsg = true;
            }
            if (openedSection) {
                this.termsAndConditions = false;
                if (id == 'yes') {
                    setTimeout(function() {
                        if (document.getElementById("first_yes")) {
                            document.getElementById("first_yes").focus();
                        }
                    }, 0);
                } else if (id == 'no') {
                    setTimeout(function() {
                        if (document.getElementById("first_no")) {
                            document.getElementById("first_no").focus();
                        }
                    }, 0);
                }
                if (typeof this.memberid !== 'undefined' && this.memberid !== 'null') {
                    let clickEvent = '';
                    if (value.search(/Share Advice/i) === 0) {
                        clickEvent = 'MemberClickShareAdvice';
                    } else if (value.search(/Call Me/i) === 0) {
                        clickEvent = 'MemberAskForCall';
                    } else if (value.search(/Let's Connect/i) === 0) {
                        clickEvent = 'MemberClickConnect';
                    } else if (value.search(/Not Available/i) === 0) {
                        clickEvent = 'MemberNotAvailable';
                    } else if (value.search(/Not Relevant/i) === 0) {
                        clickEvent = 'MemberNotAFit';
                    } else if (value.search(/Not A Good Question/i) === 0) {
                        clickEvent = 'MemberReportBadRequest';
                    }
                    this.$gtm.enable(true)
                    this.$gtm.trackEvent({
                        'RequestID': this.ask._id,
                        'RequestSource': 'Web',
                        'RequestReceived': this.$moment(this.ask.createdAt).tz("America/New_York").format('YYYYMMDD'),
                        'Community': this.ask.community.name,
                        'Circle': this.circleId,
                        'MemberID': this.memberid,
                        'MemberRole': 'Advisor',
                        'event': clickEvent
                    });
                }
                var index = "";
                if (this.action === 'yes') {
                    this.buttonText = value;
                    if (value.search(/Let's Connect/i) === -1 || value.search(/Share Advice/i) === -1 || value.search(/Call Me/i) === -1) {
                        this.$validator.reset();
                        this.buttonText = value;
                        this.contactInfoDetected = null;
                        this.remainingCount = 5000;
                        this.textError = false;
                        this.exceedsMaxCount = false;
                        this.isSubmitBtnDisabled = true;
                        index = this.opened.indexOf(id);
                        if (index >= 0) {
                            // console.log(this.buttonText);
                        } else {
                            this.opened.push(id);
                        }
                        return false;
                    } else {
                        if (this.memberid === 'undefined' || typeof this.memberid === 'undefined' || this.memberid === 'null' || this.memberid === '') {
                            this.buttonText = value;
                            this.contactInfoDetected = null;
                            index = this.opened.indexOf(id);
                            if (index >= 0) {
                                // console.log(this.buttonText);
                            } else {
                                this.opened.push(id);
                            }
                            return false;
                        } else {
                            //this.$validator.errors.clear();
                            this.$validator.reset();
                            this.helpaction(value);
                        }
                    }
                } else {
                    this.$validator.errors.clear();
                    if (this.memberid === 'undefined' || this.action === 'no' && typeof this.memberid === 'undefined' || this.memberid === 'null' || this.action === 'no' || this.memberid === '' || this.action === 'no') {
                        this.buttonText = value;
                        index = this.opened.indexOf(id);
                        if (index >= 0) {
                            // console.log(this.buttonText);
                        } else {
                            this.opened.push(id);
                        }
                        if (this.memberid !== 'undefined' && typeof this.memberid !== 'undefined' && this.memberid !== 'null' && this.memberid !== '') {
                            this.helpaction(value);
                            if (value.search(/Not Relevant/i) === 0) {
                                if (this.isUpdateProfileFlag) {
                                    document.title = 'Update Your Information';
                                } else {
                                    document.title = 'Thank You';
                                }
                                this.success = true;
                                this.successReferral = true;
                                window.scrollTo(0, 0);
                                if (this.isUpdateProfileFlag) {
                                    setTimeout(function () {
                                        document.getElementById("update-profile-btn").focus();
                                    }, 500);
                                }
                            }
                        }
                        return false;
                    } else {
                        this.helpaction(value);
                    }
                }
            }
        },
          countdown: function () {
              this.remainingCountCall = this.max - (this.callMessage ? this.callMessage.length : 0);
              this.remainingCountAdvice = this.max - (this.feedback_comment ? this.feedback_comment.length : 0);
              this.remainingCountConnect = this.max - (this.feedback_comment2 ? this.feedback_comment2.length : 0);

              if (this.buttonText.search(/Share Advice/i) !== -1) {
                  this.remainingCount = this.remainingCountAdvice;
              } else if (this.buttonText.search(/Let's Connect/i) !== -1) {
                  this.remainingCount = this.remainingCountConnect;
              } else if (this.buttonText.search(/Call Me/i) !== -1) {
                  this.remainingCount = this.remainingCountCall;
              } else {
                  this.remainingCount = this.max;
              }

              this.textError = this.remainingCount < 1000;
              this.exceedsMaxCount = this.remainingCount === 0;
          },
		submitReferral: async function(scope) {
			var parameters = {};
    	       this.$validator.validateAll(scope).then(async result => {
    		    if (result) {
						parameters = {
							askId: this.askid,
							giveId: this.giveId,
							referral: this.referral,
							memberId: this.memberid,
                            calltext: this.callText,
                            profileUpdateFlag: this.adviser.profileValidationFlag
						}
                    this.requestGiveId = this.giveId;
                    this.success = true;
                    this.successReferral = true;
                    window.scrollTo(0, 0);
                    if (typeof this.memberid !== 'undefined' && this.memberid !== 'null') {
                        if (this.isUpdateProfileFlag) {
                            document.title = 'Update Your Information';
                        } else {
                            document.title = 'Thank You';
                        }
                        if (this.isUpdateProfileFlag) {
                            setTimeout(function () {
                                document.getElementById("update-profile-btn").focus();
                            }, 500);
                        }
                        this.$gtm.enable(true)
                        this.$gtm.trackEvent({
                            'RequestID': this.ask._id,
                            'RequestSource': 'Web',
                            'RequestReceived': this.$moment(this.ask.createdAt).tz("America/New_York").format('YYYYMMDD'),
                            'Community': this.ask.community.name,
                            'Circle': this.circleId,
                            'MemberID': this.memberid,
                            'MemberRole': 'Advisor',
                            'event': 'MemberShareRequest'
                        });
                    } else {
                        document.title = 'Thank You';
                    }
					this.api
					.post(`referral-request`, parameters)
					.then(response => {
					});
				} else {
                    const firstErrorField = this.$validator.errors.items[0].field;
                    if (firstErrorField && this.$refs[firstErrorField]) {
                        this.$refs[firstErrorField].focus();
                    }
                }
			});
		},
    	countdownReferral: function() {
            this.remainingCountReferral = this.maxReferral - this.referral.message.length;
            this.remainingCountReferral === 0
            ? (this.exceedsMaxCountReferral = true)
            : (this.exceedsMaxCountReferral = false);
        },
        updateAriaExpanded(state) {
            this.isExpanded = state;
        },
        async submitNegativeResponse(action, value) {
            let parameters = {};
            window.scrollTo(0, 0);
            if (this.action === 'no' && this.memberid === 'undefined' || this.action === 'no' && typeof this.memberid === 'undefined' || this.memberid === '' || this.memberid === 'null' || this.memberid === null) {
                parameters = {
                    action: action.trim(),
                    email: this.email ? this.email.toLowerCase() : '',
                    help: 'request-help',
                    helpaction: this.action,
                    reason: value.trim(),
                    giveId: this.giveId
                    };
                    if (this.$route.query.referralid) {
                        parameters.helpactionType = 'referral';
                        parameters.referralid = this.$route.query.referralid;
                    }
            } else {
                parameters = {
                    advisors: [this.memberid],
                    action: action.trim(),
                    help: 'request-help',
                    helpaction: this.action,
                    reason: value.trim(),
                    giveId: this.giveId
                    };
                    if (this.$route.query.referralid) {
                        parameters.helpactionType = 'referral';
                        parameters.referralid = this.$route.query.referralid;
                    }
            }
            if (value.length) {
                this.success = true;
                this.successReferral = true;
                if (this.isUpdateProfileFlag) {
                    document.title = 'Update Your Information';
                } else {
                    document.title = 'Thank You';
                }
                this.api
                .post(`asks/${this.ask._id}/request-help`, parameters)
                .then(response => {
                    setTimeout(() => {
                        if (this.isUpdateProfileFlag) {
                            setTimeout(function () {
                                document.getElementById("update-profile-btn").focus();
                            }, 500);
                        }
                    }, 500);
                    if (response.data.giveId) {
                        this.giveId = response.data.giveId;
                        this.requestGiveId = response.data.giveId;
                    }
                });
                if (action.search(/Not A Good question/i) === 0 && value && typeof this.memberid !== 'undefined' && this.memberid !== 'null') {
                    this.$gtm.enable(true)
                    this.$gtm.trackEvent({
                        'RequestID': this.ask._id,
                        'RequestSource': 'Web',
                        'RequestReceived': this.$moment(this.ask.createdAt).tz("America/New_York").format('YYYYMMDD'),
                        'Community': this.ask.community.name,
                        'Circle': this.circleId,
                        'MemberID': this.memberid,
                        'MemberRole': 'Advisor',
                        'event': 'MemberSetReasonOfBadRequest'
                    });
                } else {
                    if (this.advisorThankYou && !this.isUpdateProfileFlag) {
                        window.open(this.advisorThankYou, '_self');
                    } else {
                        document.title = 'Thank You';
                        this.success = true;
                        window.scrollTo(0, 0);
                    }
                }
            }
        },
        replaceMessage() {
            if (this.referral && this.referral.message) {
                var regexPattern = new RegExp("{{ community.name }}", 'i');
                if (this.community && this.community.name) {
                    this.referral.message = this.referral.message.replace(regexPattern, this.community.name);
                } else {
                    this.referral.message = this.referral.message.replace(regexPattern, '');
                }
            }
        },
        async updateActions() {
            if (this.giveId) {
                var parameters = {};
                if (this.memberid === 'undefined' || typeof this.memberid === 'undefined' || this.memberid === '' || this.memberid === 'null' || this.memberid === null) {
                    parameters = {
                        email: this.sanitizeInput(this.email).toLowerCase(),
                        action: "N/A",
                        help: 'request-help',
                        helpaction: this.action,
                        giveId: this.giveId,
                        referralid: this.$route.query.referralid
                    };
                } else {
                    parameters = {
                        advisors: [this.memberid],
                        action: "N/A",
                        help: 'request-help',
                        helpaction: this.action,
                        giveId: this.giveId
                    };
                }
                window.scrollTo(0, 0);
                this.api
                .post(`asks/${this.ask._id}/update-actions`, parameters)
                .then(response => {
                    if (response.data.giveId) {
                        this.giveId = response.data.giveId;
                        this.requestGiveId = response.data.giveId;
                    }
                });
            }
        },
        shareRequest: function () {
            console.log("share request...");
            this.$router.push({path: `/request-share/?askid=${this.askid}&memberid=${this.memberid}&helpaction=no&action=share`});
        },
        // changeMyMind: function() {
        //     if (this.memberid != 'undefined' && typeof this.memberid != 'undefined' && this.memberid != 'null' && this.memberid != '') {
        //         if (this.community.rules && this.community.rules && this.community.rules.termsAndConditions == true && !this.adviser.termsAccepted) {
        //             this.termsAndConditions = true;
        //             this.checkedTerms = false;
        //         }
        //     }
        //     this.buttonText = '';
        //     if (this.action == 'no') {
        //         setTimeout(function () {
        //             if (this.actionPageType === 'defPage') {
        //                 document.getElementById("shareAdviceBtn").focus();
        //             }
        //         }, 100);
        //     } else if (this.action == 'yes') {
        //         setTimeout(function () {
        //             document.getElementById("notAvailableBtn").focus();
        //         }, 100);
        //     }
        //     this.$router.push({path: `/request-help/?memberid=${this.memberid}&askid=${this.askid}&circle=${this.circleId}&helpaction=${this.action === 'yes' ? 'no' : 'yes'}${this.$route.query.referralid ? '&referralid=' + this.$route.query.referralid : ''}${this.$route.query.action ? '&action=' + this.$route.query.action : ''}`});
        //     if (typeof this.memberid !== 'undefined' && this.memberid !== 'null') {
        //         this.$gtm.enable(true)
        //         this.$gtm.trackEvent({
        //             'RequestID': this.ask._id,
        //             'RequestSource': 'Web',
        //             'RequestReceived': this.$moment(this.ask.createdAt).tz("America/New_York").format('YYYYMMDD'),
        //             'Community': this.ask.community.name,
        //             'Circle': this.circleId,
        //             'MemberID': this.memberid,
        //             'MemberRole': 'Advisor',
        //             'event': 'MemberChangeTheMind'
        //         });
        //     }
        // },
        clickUpdateProfile(status) {
            if (typeof this.memberid !== 'undefined' && this.memberid !== 'null' && status && this.infoHasChanged) {
                this.$gtm.enable(true)
                this.$gtm.trackEvent({
                    'RequestID': this.ask._id,
                    'RequestSource': 'Web',
                    'RequestReceived': this.$moment(this.ask.createdAt).tz("America/New_York").format('YYYYMMDD'),
                    'Community': this.ask.community.name,
                    'Circle': this.circleId,
                    'MemberID': this.memberid,
                    'MemberRole': 'Advisor',
                    'event': 'MemberClickUpdateProfile'
                });
            }
        },
        editProfile: function() {
            this.isEditing = true;
            // this.buttonToggle = true;

        },
        saveProfile: async function(status, booleanVal = true) {
            this.buttonToggle = false;
            var memberUpdateData = {
                requestId: this.ask._id,
                giveId: this.requestGiveId,
                communityId: this.community._id,
                community: this.community.name,
                circleId: this.circleId,
                memberId: this.adviser._id,
                propertyId: this.adviser.propertyId,
                name: this.adviser.displayName && (typeof this.adviser.displayName !== 'undefined' || this.adviser.displayName !== '') ? this.adviser.displayName : this.adviser.first + ' ' + this.adviser.last,
                email: this.adviser.emails.toString(),
                memberObj: this.memberObj
            };
            if (status == 'customer') {
                memberUpdateData.status = status
                memberUpdateData.sendMailToSuperUser = true;
            }
            //delete memberUpdateData.memberObj.interests;
            if (this.adviser && this.adviser.profileValidationFlag == this.configureFields.profileUpdateInterest) {
                const existingInterests = memberUpdateData.memberObj.interests || [];
                const newInterests = this.selectedInterestList || [];
                memberUpdateData.memberObj.interests = [...new Set([...existingInterests, ...newInterests])];
            } else {
                delete memberUpdateData.memberObj.interests;
            }
            memberUpdateData.email = memberUpdateData.email ? memberUpdateData.email.toLowerCase() : '';
            if (this.adviser && this.adviser.profileValidationFlag != this.configureFields.profileUpdateInterest) {
                //this.isEditing = false;
            }
            // Only write phone if user actually entered one
            const newPhone = (this.phoneInput || "").trim();
            const oldPhone =
                Array.isArray(this.memberObj.phoneNumbers) && this.memberObj.phoneNumbers.length
                    ? String(this.memberObj.phoneNumbers[0]).trim()
                    : "";

            if (newPhone && newPhone !== oldPhone) {
                this.memberObj.phoneNumbers = [newPhone];
            } else {
                delete this.memberObj.phoneNumbers;
            }

            console.log("memberdata: ", memberUpdateData);
            await this.api.post(`members/profile-update`, memberUpdateData).then(response => {
                this.clickUpdateProfile(false);
                this.adviser = this.memberObj;
                if (this.infoHasChanged) {
                    this.$refs.snackbar.open('Thank you. You have successfully updated your profile.');
                }
                this.buttonToggle = true;
            });
        },
        /*outside: function(e) {
            this.isEditing = false;
        },*/
        updateSubmitBtnDisabled: function () {
            if (this.buttonText.search(/Share Advice/i) !== -1) {
                if (this.feedback_comment.trim().length == 0) {
                    this.isSubmitBtnDisabled = true;
                } else {
                    this.isSubmitBtnDisabled = false;
                }
            } else if (this.buttonText.search(/Call Me/i) !== -1) {
                if (this.phoneNo.trim().length == 0 || this.callMessage.trim().length == 0) {
                    this.isSubmitBtnDisabled = true;
                } else {
                    this.isSubmitBtnDisabled = false;
                }
            } else {
                if (this.feedback_comment.trim().length == 0) {
                    this.isSubmitBtnDisabled = true;
                } else {
                    this.isSubmitBtnDisabled = false;
                }
            }
            // if btn is not disabled and route is for referral then check for email field
            if (this.isSubmitBtnDisabled == false && this.$route.query.referralid) {
                if (this.email.trim().length == 0 && typeof this.memberid === 'undefined' && this.memberid === 'null') {
                    this.isSubmitBtnDisabled = true;
                } else {
                    this.isSubmitBtnDisabled = false;
                }
            }
        },
        closeBtn: function() {
            window.open('', '_parent', '');
            window.close();
        },
        goToNext: async function() {
            document.title = 'Thank You';
            this.saveProfile('blank', false);
            this.isEmailSection = true;
            this.successMsg = `Would you like to help more?`;
        },
        nextElement: function(arr, target) {
            let start = 0;
            let end = arr.length - 1;
            let ans = -1;
            while (start <= end) {
                let mid = parseInt((start + end) / 2, 10);
                if (arr[mid] <= target) {
                    start = mid + 1;
                } else {
                    ans = mid;
                    end = mid - 1;
                }
            }
            return typeof arr[ans] == 'undefined' ? arr[0] : arr[ans];
        },
        setButtonState: function (buttonName) {
            Object.keys(this.buttonStates).forEach(key => {
                this.$set(this.buttonStates, key, false);
            });
            this.$set(this.buttonStates, buttonName, true);
        },
        updateButtonToggle: function() {
            this.buttonToggle = false;
        },
        findMemberSchool: async function(memberId) {
            await this.api.get(`members/${memberId}`).then(member => {
                    if (member.data._id) {
                        this.memberSchool = member.data.school1;
                    }

            })
        },
        createReferralMember: async function(firstName, lastName, email, communityId, circleId) {
            let params = {
                first: firstName,
                last: lastName,
                email: email,
                community: communityId,
                circles: circleId,
                memberType: 'Referral'
            }
            let referral = null;
      await this.api.post(`members/create-member`, params).then(response => {
        if (response.data) {
          console.log(response.data)
          referral = response.data._id;
          console.log('referral', referral)
        }
      });
      return referral
    }
  }
};
</script>

<style scoped>
/* :root {
  '--secondary-color': {{styleBtn.color}};
  '--secondary-background-color': {{styleBtn.colorBackd}};
  '--primary-color': {{styleBtn.colorHover}};
  '--primary-background-color': {{styleBtn.colorBackdHover}};
} */
.contact-detection-banner {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    background-color: #FEF3EE;
    border: 1px solid #F5C9B3;
    border-radius: 8px;
    padding: 14px 16px 14px 16px;
    margin-top: 12px;
    margin-bottom: 12px;
    width: 100%;
    box-sizing: border-box;
    font-family: inherit;
}

.contact-detection-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 22px;
    height: 22px;
    background-color: #F97316;
    color: #fff;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 700;
    margin-top: 1px;
    flex-shrink: 0;
    font-family: inherit;
}

.contact-detection-text {
    flex: 1;
    font-family: inherit;
}

.contact-detection-text strong {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 3px;
    font-family: inherit;
}

.contact-detection-text p {
    font-size: 13px;
    color: #555;
    margin: 0;
    line-height: 1.5;
    font-family: inherit;
}

.placeholder-bold::placeholder {
  font-weight: 700 !important;
}
.refresh:hover {
  text-decoration: underline;
}
.update-request-form-common .yesBtn {
  color: var(--styleBtn-color);
  background-color: var(--styleBtn-background-color);
}

.update-request-form-common .yesBtn:hover, .update-request-form-common .yesBtn.md-focused, #shareAdviceBtn.focus-visible, .shareAdviceBtn:focus, .active, .update-request-form-common .yesBtn:focus {
  color: var(--styleBtn-color--hover) !important;
  background-color: var(--styleBtn-background-color--hover) !important;
}
.submitBtn {
  color: var(--styleBtn-color) !important;
  background-color: var(--styleBtn-background-color) !important;
}
.submitBtn:hover,
.submitBtn:focus {
  color: var(--styleBtn-color--hover) !important;
  background-color: var(--styleBtn-background-color--hover) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/EmailRequest.vue